{
  "site.description": "Management platform for landlords",
  "appAdvertising.ariaLabel": "Sponsored space",
  "appAdvertising.eyebrow": "Sponsored",
  "appAdvertising.title": "A relevant partner campaign for landlords",
  "appAdvertising.body": "This subtle slot is reserved for a vertical campaign or partner message that fits day-to-day property administration.",
  "appAdvertising.meta": "Admins can disable this slot across the platform.",
  "language.label": "Language",
  "language.nl": "Dutch",
  "language.fr": "French",
  "language.en": "English",
  "language.de": "German",
  "common.loading": "Loading...",
  "common.today": "today",
  "common.tomorrow": "tomorrow",
  "common.actions": "Actions",
  "common.details": "Details",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.download": "Download",
  "common.export": "Export",
  "common.upload": "Upload",
  "common.generating": "Generating...",
  "common.uploading": "Uploading...",
  "common.add": "Add",
  "common.create": "Create",
  "common.save": "Save",
  "common.saving": "Saving...",
  "common.deleting": "Deleting...",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.copy": "Copy",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.finish": "Finish",
  "common.confirm": "Confirm",
  "common.all": "All",
  "common.none": "None",
  "common.open": "Open",
  "common.completed": "Completed",
  "common.undo": "Undo",
  "common.overdue": "Overdue",
  "common.soon": "Soon",
  "common.active": "Active",
  "common.ended": "Ended",
  "common.status": "Status",
  "common.type": "Type",
  "common.title": "Title",
  "common.date": "Date",
  "common.description": "Description",
  "common.notes": "Notes",
  "common.notesPlaceholder": "Agreements, special clauses, links or internal notes...",
  "common.tags": "Tags",
  "common.address": "Address",
  "common.property": "Property",
  "common.tenant": "Tenant",
  "common.photos": "Photos",
  "common.document": "Document",
  "common.documents": "Documents",
  "common.reminder": "Reminder",
  "common.reminders": "Reminders",
  "common.deadline": "Deadline",
  "common.startDate": "Start date",
  "common.endDate": "End date",
  "common.name": "Name",
  "common.email": "Email",
  "common.phone": "Phone",
  "common.phoneNumber": "Phone number",
  "common.file": "File",
  "common.category": "Category",
  "common.expiryDate": "Expiry date",
  "common.added": "Added",
  "common.linkedTo": "Linked to",
  "common.noLink": "- No link -",
  "common.optional": "(optional)",
  "common.required": "*",
  "common.orSkip": "or skip this step",
  "common.errorGeneric": "Something went wrong. Please try again.",
  "apiError.invalidRequest": "The request is incomplete or invalid.",
  "apiError.badRequest": "The request could not be completed.",
  "apiError.unauthorized": "Your session could not be verified. Please sign in again.",
  "apiError.paymentRequired": "Your subscription does not allow this action right now.",
  "apiError.forbidden": "You are not allowed to perform this action.",
  "apiError.notFound": "The requested item could not be found.",
  "apiError.conflict": "This action could not be completed right now.",
  "apiError.invalidOperation": "This action could not be completed.",
  "apiError.invalidVatNumber": "The VAT number is invalid. Check the number and try again.",
  "apiError.argument": "Some data is invalid. Check your input and try again.",
  "apiError.argumentOutOfRange": "One of the values is outside the allowed range.",
  "apiError.billingProvider": "The payment provider could not complete this action right now.",
  "auth.login": "Log in",
  "auth.logout": "Log out",
  "auth.startFree": "Start free",
  "auth.dashboard": "Dashboard",
  "auth.successTitle": "Check your inbox",
  "auth.loginWithEmail": "Send sign-in link",
  "auth.loginWithGoogle": "Continue with Google",
  "auth.loginWithMicrosoft": "Continue with Microsoft",
  "auth.emailLabel": "Email address",
  "auth.emailPlaceholder": "name@example.com",
  "auth.emailRequired": "Enter your email address first.",
  "auth.emailLinkSent": "We sent a sign-in link to your email address.",
  "auth.emailLoginFailed": "Email sign-in failed.",
  "auth.emailProvider": "Email",
  "auth.loggingIn": "Signing in...",
  "auth.loginUnavailable": "Sign-in is currently unavailable. Please try again later.",
  "auth.noLoginProviders": "There are currently no sign-in methods available.",
  "auth.googleLoginFailed": "Google sign-in failed.",
  "auth.microsoftLoginFailed": "Microsoft sign-in failed.",
  "auth.authProviderDisabled": "This sign-in method is currently disabled.",
  "auth.accountBlocked": "This account has been blocked. Please contact the helpdesk.",
  "auth.signupDisabled": "New account access is currently disabled. Please contact the helpdesk.",
  "auth.signupNotification.body": "Leave your email address if you want to allow a one-time email when Rentomax becomes available again for new users.",
  "auth.signupNotification.emailLabel": "Email address",
  "auth.signupNotification.emailPlaceholder": "name@example.com",
  "auth.signupNotification.submit": "Notify me",
  "auth.signupNotification.successTitle": "You are on the list",
  "auth.signupNotification.success": "We will send you a one-time email when new accounts are allowed again.",
  "auth.signupNotification.invalidEmail": "Enter a valid email address.",
  "auth.signupNotification.missingContext": "We could no longer verify your sign-in context. Please try signing in again.",
  "auth.signupNotification.saveError": "Your request could not be saved. Please try again.",
  "auth.errorTitle": "Sign-in unavailable",
  "accessGuard.checkFailed": "We could not verify your access right now. Please try again.",
  "auth.countryNotAllowed": "Rentomax is not available in your country yet.",
  "auth.platformCountryNotAllowed": "Your session was ended because access from your country is not allowed on Rentomax.",
  "auth.countryUnverified": "We could not verify your country. Please try again later.",
  "country.AT": "Austria",
  "country.BE": "Belgium",
  "country.BG": "Bulgaria",
  "country.HR": "Croatia",
  "country.CY": "Cyprus",
  "country.CZ": "Czechia",
  "country.DK": "Denmark",
  "country.EE": "Estonia",
  "country.FI": "Finland",
  "country.FR": "France",
  "country.DE": "Germany",
  "country.GR": "Greece",
  "country.HU": "Hungary",
  "country.IE": "Ireland",
  "country.IT": "Italy",
  "country.LV": "Latvia",
  "country.LT": "Lithuania",
  "country.LU": "Luxembourg",
  "country.MT": "Malta",
  "country.NL": "Netherlands",
  "country.PL": "Poland",
  "country.PT": "Portugal",
  "country.RO": "Romania",
  "country.SK": "Slovakia",
  "country.SI": "Slovenia",
  "country.ES": "Spain",
  "country.SE": "Sweden",
  "nav.dashboard": "Dashboard",
  "nav.calendar": "Calendar",
  "nav.properties": "Properties",
  "nav.tenants": "Tenants",
  "nav.documents": "Documents",
  "nav.reminders": "Reminders",
  "nav.damageReports": "Damage reports",
  "nav.waitinglist": "Waiting list",
  "nav.contractors": "Contractors",
  "nav.features": "Features",
  "nav.pricing": "Pricing",
  "nav.help": "Help",
  "nav.tenantActiveAgreements": "Active rental agreements",
  "nav.tenantUpcomingAgreements": "Upcoming rental agreements",
  "nav.tenantApplications": "Applications",
  "nav.tenantPastAgreements": "Past rental agreements",
  "footer.tagline": "The smart platform for landlords in Belgium and the Netherlands.",
  "footer.product": "Product",
  "footer.support": "Support",
  "footer.contact": "Contact",
  "footer.legal": "Legal",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
  "footer.copyright": "All rights reserved.",
  "legal.eyebrow": "Legal",
  "legal.updated": "Last updated: June 23, 2026",
  "legal.common.companyLabel": "Company",
  "legal.common.addressLabel": "Country of establishment",
  "legal.common.companyNumberLabel": "Company number",
  "legal.common.vatLabel": "VAT number",
  "legal.common.emailLabel": "Email",
  "legal.common.websiteLabel": "Website",
  "legal.privacy.hero.title": "Privacy Policy",
  "legal.privacy.hero.body": "This privacy policy explains how Ceustermans IT BV processes personal data in connection with Rentomax and the public website.",
  "legal.privacy.controller.title": "1. Data controller",
  "legal.privacy.controller.body": "Ceustermans IT BV is the data controller for the personal data processed through Rentomax and the public website.",
  "legal.privacy.scope.title": "2. What data does this policy cover?",
  "legal.privacy.scope.body": "This policy applies to personal data we process when you visit the website, create an account, sign in, request support, use a trial or subscription, or store data in Rentomax.",
  "legal.privacy.scope.item1": "Identity and contact data such as name, email address, phone number and address details.",
  "legal.privacy.scope.item2": "Account and profile data such as account mode, language preference, sign-in provider and onboarding status.",
  "legal.privacy.scope.item3": "Subscription and billing data such as selected plan, payment status, invoices, credit notes and business or VAT details.",
  "legal.privacy.scope.item4": "User content stored in the service, such as properties, tenants, agreements, documents, photos, reminders and reports.",
  "legal.privacy.scope.item5": "Technical data such as IP address, device and browser information, logs and local preferences needed for security and operation.",
  "legal.privacy.collection.title": "3. How do we collect personal data?",
  "legal.privacy.collection.item1": "Directly from you when you complete forms, sign in, ask for support or store data in the app.",
  "legal.privacy.collection.item2": "Through Google or Microsoft when you choose to sign in with one of those providers.",
  "legal.privacy.collection.item3": "Through payment and billing partners when a trial, payment, subscription change or refund is processed.",
  "legal.privacy.collection.item4": "Automatically through logs, cookies and local storage required to keep the website and app secure and usable.",
  "legal.privacy.google.title": "4. Google user data for sign-in",
  "legal.privacy.google.body1": "If you choose Sign in with Google, Rentomax requests only the openid, email and profile scopes. Through those scopes we receive your Google account ID, email address and profile name.",
  "legal.privacy.google.body2": "We use this Google user data only to authenticate you, create or link your Rentomax account, keep your chosen sign-in provider on record and show your name or email address in your account. We do not use this data for advertising or to train generalized AI or ML models.",
  "legal.privacy.google.item1": "The authorization code and tokens returned by Google during sign-in are used only during the backend sign-in flow to verify your identity.",
  "legal.privacy.google.item2": "We do not use the Google access token to read or modify Gmail, Drive, Calendar, Contacts or other Google APIs, and we do not keep that access token after sign-in.",
  "legal.privacy.google.item3": "We may store the Google account ID, email address and profile name in your Rentomax account record for account access, security, support and account recovery, or longer if a legal retention duty applies.",
  "legal.privacy.purposes.title": "5. Why do we process personal data and on which legal basis?",
  "legal.privacy.purposes.item1": "To create your account, authenticate you and give you access to Rentomax. Legal basis: performance of a contract or steps prior to entering into a contract.",
  "legal.privacy.purposes.item2": "To deliver the service, store data, display dossiers and run functions such as documents, photos, reminders and tenant flows. Legal basis: performance of a contract.",
  "legal.privacy.purposes.item3": "To manage payments, subscriptions, invoices, refunds and required accounting administration. Legal basis: performance of a contract and legal obligations.",
  "legal.privacy.purposes.item4": "To answer support requests and send operational messages. Legal basis: legitimate interests and, where relevant, steps prior to entering into a contract.",
  "legal.privacy.purposes.item5": "To secure the website and app, prevent abuse, investigate incidents and monitor performance. Legal basis: legitimate interests.",
  "legal.privacy.purposes.item6": "To send you a one-time message when new account access is reopened, if you explicitly ask for it. Legal basis: consent.",
  "legal.privacy.cookies.title": "6. Cookies, local storage and sign-in technology",
  "legal.privacy.cookies.body1": "Rentomax uses functional cookies and local storage to operate the website and app, for example for language choice, session security, sign-in state, post-login redirects, consent choices and interface preferences.",
  "legal.privacy.cookies.body2": "When you choose Google or Microsoft sign-in, we load the required sign-in scripts from those providers to enable authentication. Those providers also process data under their own privacy terms.",
  "legal.privacy.sharing.title": "7. Who do we share personal data with?",
  "legal.privacy.sharing.body": "We do not sell your personal data. We only share personal data when needed to deliver Rentomax, process payments, provide hosting, send email, protect the service or comply with law.",
  "legal.privacy.sharing.item1": "Payment processing and subscription management through Mollie.",
  "legal.privacy.sharing.item2": "Authentication through Google and Microsoft when you use those sign-in methods.",
  "legal.privacy.sharing.item3": "Storage and infrastructure through Supabase and Azure.",
  "legal.privacy.sharing.item4": "Transactional email delivery through Resend.",
  "legal.privacy.sharing.item5": "Professional advisers, competent authorities or courts when reasonably necessary or legally required.",
  "legal.privacy.transfers.title": "8. International transfers",
  "legal.privacy.transfers.body": "Some suppliers or their subprocessors may process personal data outside the European Economic Area. In that case we rely on a valid transfer mechanism, such as an adequacy decision or appropriate contractual safeguards.",
  "legal.privacy.retention.title": "9. Retention",
  "legal.privacy.retention.body1": "We do not keep personal data longer than necessary for the purposes for which it was collected, unless a longer retention period is legally required or operationally justified.",
  "legal.privacy.retention.item1": "Account and dossier data are generally kept while the account remains active and afterwards for as long as needed for closure, backups, disputes or legal obligations.",
  "legal.privacy.retention.item2": "Billing and transaction documents are kept for as long as required by applicable accounting and tax rules.",
  "legal.privacy.retention.item3": "Support requests, security logs and technical backups are kept for as long as reasonably necessary for support, security and recovery.",
  "legal.privacy.security.title": "10. Security",
  "legal.privacy.security.body": "We take reasonable technical and organisational measures to protect personal data against loss, unauthorised access, misuse, alteration or disclosure. No storage or transmission method is entirely risk free.",
  "legal.privacy.rights.title": "11. Your rights",
  "legal.privacy.rights.body": "Under the GDPR, depending on the situation, you may have rights of access, rectification, erasure, restriction, data portability and objection to certain processing. Where processing is based on consent, you can also withdraw that consent.",
  "legal.privacy.rights.body2": "You can send your request to <a href=\"mailto:admin@rentomax.be\">admin@rentomax.be</a>. We may ask for reasonable verification before acting on a request.",
  "legal.privacy.complaints.title": "12. Complaints and contact",
  "legal.privacy.complaints.body1": "If you have questions about this privacy policy or about how Rentomax processes personal data, contact us at <a href=\"mailto:admin@rentomax.be\">admin@rentomax.be</a>.",
  "legal.privacy.complaints.body2": "You also have the right to lodge a complaint with the Belgian Data Protection Authority or the supervisory authority in the EU country where you live or work.",
  "legal.terms.hero.title": "Terms of Service",
  "legal.terms.hero.body": "These terms govern your access to and use of Rentomax as an administrative software service for landlords and rental businesses.",
  "legal.terms.provider.title": "1. Provider",
  "legal.terms.provider.body": "Rentomax is provided by Ceustermans IT BV, Belgium, company number 0783 289 846 and VAT number BE0783 289 846.",
  "legal.terms.provider.body2": "For questions about these terms, contact <a href=\"mailto:admin@rentomax.be\">admin@rentomax.be</a>.",
  "legal.terms.scope.title": "2. Service and scope",
  "legal.terms.scope.body1": "Rentomax is an online administrative tool for landlords, self-employed lessors, companies and other rental businesses. The service helps users organise properties, tenants, agreements, documents, reminders, events and related dossiers.",
  "legal.terms.scope.body2": "Rentomax is not a legal, tax, accounting or compliance product and does not provide legal advice or automated legal assessments.",
  "legal.terms.accounts.title": "3. Accounts and access",
  "legal.terms.accounts.item1": "You are responsible for the accuracy of the account information you provide and for the safe use of your account.",
  "legal.terms.accounts.item2": "You may only use Rentomax for legitimate administrative purposes within your own organisation, activity or rental context.",
  "legal.terms.accounts.item3": "You remain responsible for all actions performed through your account unless you notify us of a security incident in time.",
  "legal.terms.accounts.item4": "We may refuse, restrict or block access where reasonably necessary to prevent fraud, abuse, security incidents or breach of contract.",
  "legal.terms.acceptableUse.title": "4. Acceptable use",
  "legal.terms.acceptableUse.item1": "You must not use the service in a way that is unlawful, misleading, harmful or infringing.",
  "legal.terms.acceptableUse.item2": "You must not upload or distribute viruses, malware, unauthorised scripts or other harmful code through Rentomax.",
  "legal.terms.acceptableUse.item3": "You must not try to access, interfere with or reverse engineer the service, underlying systems or other users' accounts without authorisation, except where mandatory law permits it.",
  "legal.terms.acceptableUse.item4": "You must not use the service to process personal data if you do not have a valid legal basis or required permission for that processing.",
  "legal.terms.customerData.title": "5. Your data and content",
  "legal.terms.customerData.body1": "As between you and Ceustermans IT BV, you retain ownership of the content and data you enter or upload into Rentomax to the extent permitted by law.",
  "legal.terms.customerData.body2": "You represent that you have the necessary rights and permissions to store and process that data in Rentomax. You are responsible for the lawfulness, quality and accuracy of that data.",
  "legal.terms.billing.title": "6. Trial periods, subscriptions and payments",
  "legal.terms.billing.item1": "Rentomax may offer a free trial period. Continued use after a trial may require a paid plan.",
  "legal.terms.billing.item2": "Paid subscriptions run for the agreed billing interval and renew automatically until cancelled.",
  "legal.terms.billing.item3": "Prices, plan limits and included storage are shown on the pricing page or inside the account environment.",
  "legal.terms.billing.item4": "Payments, refunds and subscription processing may be handled through external payment providers.",
  "legal.terms.cancellation.title": "7. Cancellation, changes and withdrawal rights",
  "legal.terms.cancellation.item1": "You can cancel a paid subscription through the available account or support channels. A regular cancellation stops future renewals at the end of the current paid period.",
  "legal.terms.cancellation.item2": "Upgrades may take effect immediately. Downgrades or reductions may take effect only from a later paid period, depending on the chosen plan and interval.",
  "legal.terms.cancellation.item3": "If you purchase a first paid subscription as a consumer, any statutory right of withdrawal may be exercised within 14 days after the start of that first paid subscription. If that right applies, we refund the paid amount and stop future renewals.",
  "legal.terms.cancellation.item4": "We may change prices or plan limits for future periods. If such a change affects your existing paid subscription, we will try to inform you in advance.",
  "legal.terms.availability.title": "8. Availability and service changes",
  "legal.terms.availability.body1": "We use reasonable efforts to keep Rentomax available, secure and usable, but we do not guarantee uninterrupted or error-free availability.",
  "legal.terms.availability.body2": "We may adjust, improve, limit or discontinue the service, features, user interface, technical infrastructure or supported integrations from time to time.",
  "legal.terms.ip.title": "9. Intellectual property",
  "legal.terms.ip.body": "All rights in Rentomax, including software, brand, design, documentation and non-user-supplied content, remain the property of Ceustermans IT BV or its licensors. These terms only grant you a limited, revocable, non-exclusive licence to use the service during your lawful use of it.",
  "legal.terms.liability.title": "10. Warranties and liability",
  "legal.terms.liability.body1": "Rentomax is provided on the basis of reasonable professional efforts. To the extent permitted by law, implied warranties are excluded.",
  "legal.terms.liability.body2": "Ceustermans IT BV is not liable for indirect damage, consequential loss, loss of profit, loss of opportunity, loss of data caused by user actions, or decisions taken solely on the basis of software output.",
  "legal.terms.liability.body3": "Nothing in these terms limits liability that cannot validly be excluded or limited under mandatory law.",
  "legal.terms.termination.title": "11. Termination",
  "legal.terms.termination.body": "We may suspend or terminate your access if you materially breach these terms, misuse the service, create security risks or leave payments unpaid, where reasonable in the circumstances.",
  "legal.terms.law.title": "12. Governing law and disputes",
  "legal.terms.law.body": "These terms are governed by Belgian law. Courts in Belgium have jurisdiction, unless mandatory consumer law requires a different competent court.",
  "richText.bold": "Bold",
  "richText.bulletList": "Bulleted list",
  "richText.numberedList": "Numbered list",
  "richText.link": "Add link",
  "richText.linkPrompt": "Enter a full link",
  "landing.hero.title": "Everything for your rental properties,<br>in one place.",
  "landing.hero.subtitle": "Rentomax is the management platform for landlords in Belgium and the Netherlands. Keep your properties, tenants, documents and deadlines organised without the hassle.",
  "landing.hero.primary": "Start free",
  "landing.hero.secondary": "Explore features",
  "landing.features.title": "A complete platform for your rental administration",
  "landing.features.subtitle": "From your first property to a larger portfolio: manage buildings, units, tenants, agreements, documents, follow-up and exports in one central workspace.",
  "landing.feature.dashboard.title": "Dashboard and portfolio overview",
  "landing.feature.dashboard.body": "See straight away what needs attention with summaries of occupancy, open follow-up items, upcoming end dates and recent activity.",
  "landing.feature.portfolio.title": "Buildings, properties and units",
  "landing.feature.portfolio.body": "Manage standalone properties or full buildings with multiple units. Each unit keeps its own dossier while shared building information stays centralised.",
  "landing.feature.tenants.title": "Tenants and prospective tenants",
  "landing.feature.tenants.body": "Store contact details, statuses, notes and history for every contact so move-outs, move-ins and follow-up stay organised.",
  "landing.feature.documents.title": "Agreements and documents",
  "landing.feature.documents.body": "Link contracts, certificates, attachments and other files to the right property, building, unit or tenant. Everything stays easy to find in one clear dossier.",
  "landing.feature.condition.title": "Condition reports with photos",
  "landing.feature.condition.body": "Capture the state of your property room by room at check-in and check-out. Work with checklists, notes and photos tied directly to the right dossier.",
  "landing.feature.welcome.title": "Welcome page per tenant",
  "landing.feature.welcome.body": "Share practical move-in and usage information through a personal link that you activate and manage for each new tenant.",
  "landing.feature.issues.title": "Damage and issue reporting",
  "landing.feature.issues.body": "Let active tenants register problems or damage with photos so you can follow up every report per agreement.",
  "landing.feature.payments.title": "Manual payment tracking",
  "landing.feature.payments.body": "Mark rent as received period by period, review the history and keep unpaid months visible without bank integrations.",
  "landing.feature.calendar.title": "Reminders, expiry dates and calendar",
  "landing.feature.calendar.body": "Plan reminders, follow up on end dates and view every important moment across your portfolio in one shared calendar overview.",
  "landing.feature.export.title": "PDF exports for dossiers",
  "landing.feature.export.body": "Assemble an export per property or tenant and bundle the right sections into one PDF for internal use or handover.",
  "landing.cta.title": "Ready to manage your rental properties better?",
  "landing.cta.body": "Start free today. No credit card required.",
  "landing.cta.button": "Create your account",
  "landing.useCases.title": "Software for landlords who want one clear overview instead of scattered tools",
  "landing.useCases.subtitle": "Rentomax brings your day-to-day rental administration together in one workspace that scales from a first property to a broader portfolio.",
  "landing.useCase.admin.title": "From property status to tenant file in one fixed place",
  "landing.useCase.admin.body": "Use Rentomax as central software for landlords to keep properties, units, tenants, agreements, and notes together per file.",
  "landing.useCase.documents.title": "Less searching across documents, photos, and expiry dates",
  "landing.useCase.documents.body": "Link documents, place descriptions, photos, and reminders to the right property or tenant so follow-up work moves faster.",
  "landing.useCase.followup.title": "More control over follow-up, onboarding, and planning",
  "landing.useCase.followup.body": "Work with reminders, calendar views, onboarding, and exports to keep your rental administration consistent as your portfolio grows.",
  "landing.guides.title": "Explore Rentomax through features, pricing, and help",
  "landing.guides.subtitle": "Each public page helps you evaluate a different part of the platform: what you manage, which plan fits, and how the day-to-day workflow looks.",
  "landing.guides.features.title": "See what you can manage in Rentomax",
  "landing.guides.features.body": "Discover how the platform brings together properties, tenants, documents, place descriptions, reminders, and PDF exports for landlords.",
  "landing.guides.features.button": "Go to features",
  "landing.guides.pricing.title": "Compare pricing for landlord software",
  "landing.guides.pricing.body": "See which plan fits a single property, a growing portfolio, or a more professional rental operation.",
  "landing.guides.pricing.button": "View pricing",
  "landing.guides.help.title": "Read how Rentomax works",
  "landing.guides.help.body": "Use the help center for onboarding, buildings with units, document follow-up, reminders, and support questions.",
  "landing.guides.help.button": "Open help center",
  "login.page.title": "Log in",
  "login.heading": "Log in",
  "login.body": "Log in to manage your properties, tenants and documents.",
  "login.footer": "No account yet? By logging in you automatically create an account.",
  "pricing.hero.title": "Simple, transparent pricing",
  "pricing.hero.subtitle": "Try Rentomax free for 14 days. No credit card required.",
  "pricing.toggle.monthly": "Monthly",
  "pricing.toggle.yearly": "Yearly",
  "pricing.toggle.saveLabel": "2 months free",
  "pricing.trial.title": "Free trial",
  "pricing.trial.desc": "Discover the platform for 2 weeks without obligation.",
  "pricing.starter.desc": "Ideal if you rent out one property.",
  "pricing.pro.desc": "For landlords with multiple properties.",
  "pricing.business.desc": "For professional property managers.",
  "pricing.custom.title": "Custom",
  "pricing.custom.desc": "More than 5 properties? We offer a custom solution.",
  "pricing.badge.popular": "Popular",
  "pricing.button.start": "Start free",
  "pricing.button.getStarted": "Get started",
  "pricing.button.choosePro": "Choose Pro",
  "pricing.button.chooseBusiness": "Choose Business",
  "pricing.button.contactSales": "Contact us",
  "pricing.questions.title": "Any questions?",
  "pricing.questions.body": "Feel free to contact us. We are happy to help.",
  "pricing.questions.button": "Contact us",
  "pricing.trial.period": "/ 14 days",
  "pricing.period.monthly": "/month incl. VAT",
  "pricing.period.yearly": "/year incl. VAT",
  "pricing.feature.fullAccess": "Full access to all features",
  "pricing.feature.documents": "Document storage",
  "pricing.feature.remindersTimeline": "Reminders and timeline",
  "pricing.feature.dashboard": "Dashboard",
  "pricing.feature.prioritySupport": "Priority support",
  "pricing.feature.dedicatedSupport": "Dedicated support",
  "pricing.trial.feature.storage": "1 GB storage, good for about 500 documents or photos",
  "pricing.starter.feature.properties": "1 property",
  "pricing.starter.feature.storage": "1 GB storage, good for about 500 documents or photos",
  "pricing.pro.feature.properties": "Up to 3 properties",
  "pricing.pro.feature.storage": "3 GB storage, good for about 1,500 documents or photos",
  "pricing.business.feature.properties": "Up to 5 properties",
  "pricing.business.feature.storage": "10 GB storage, good for about 5,000 documents or photos",
  "pricing.custom.feature.properties": "Unlimited properties",
  "pricing.custom.feature.includes": "Everything in Business",
  "pricing.custom.feature.storage": "Custom storage capacity",
  "pricing.custom.feature.price": "Custom pricing",
  "pricing.storageEstimateNote": "Estimate based on an average file size of 2 MB per document or photo. PDFs are often smaller, photos can be larger.",
  "pricing.fit.title": "Which plan fits your rental administration?",
  "pricing.fit.subtitle": "Use this guide to choose faster based on the number of properties, the amount of follow-up work, and the scale of your portfolio.",
  "pricing.fit.starter.title": "Starter for a first property or compact portfolio",
  "pricing.fit.starter.body": "Choose Starter if you mainly want to manage one property, the linked tenant, documents, and reminders in one fixed place.",
  "pricing.fit.pro.title": "Pro for landlords with multiple properties",
  "pricing.fit.pro.body": "Choose Pro if you follow up several files at once and want more room for documents, place descriptions, and daily tracking.",
  "pricing.fit.business.title": "Business for a broader or more professional operation",
  "pricing.fit.business.body": "Choose Business if you structure your rental administration across multiple properties and need more storage and support.",
  "pricing.faq.title": "Frequently asked questions about pricing and plans",
  "pricing.faq.intro": "These short answers help you estimate which plan best matches your properties, documents, and day-to-day follow-up.",
  "pricing.faq.starter.question": "Who is Starter best suited for?",
  "pricing.faq.starter.answer": "Starter fits landlords who want to manage a first property or a limited rental file centrally without unnecessary complexity.",
  "pricing.faq.scale.question": "When should I choose Pro or Business instead?",
  "pricing.faq.scale.answer": "Pro and Business fit better once you manage multiple properties, need more storage, and want more structure across several files.",
  "pricing.faq.trial.question": "Can I start free first and choose a plan later?",
  "pricing.faq.trial.answer": "Yes. You can test Rentomax free for 14 days and only then decide which plan best fits your portfolio and working method.",
  "pricing.faq.contact.question": "Where do I ask questions about subscriptions or a custom quote?",
  "pricing.faq.contact.answer": "Use the help center or contact form to discuss subscriptions, larger portfolios, or a tailored setup.",
  "pages.home.title": "Manage your rental properties with ease",
  "pages.pricing.title": "Pricing",
  "pages.privacy.title": "Privacy Policy",
  "pages.privacy.description": "Read how Ceustermans IT BV processes personal data for Rentomax, which rights you have and how to contact us about privacy.",
  "pages.terms.title": "Terms of Service",
  "pages.terms.description": "Read the Rentomax terms covering account rules, subscription terms, cancellation, liability and contact details.",
  "pages.login.title": "Log in",
  "pages.dashboard.title": "Dashboard",
  "pages.calendar.title": "Calendar",
  "pages.properties.title": "Properties",
  "pages.damageReports.title": "Damage reports",
  "pages.propertyDetail.title": "Property details",
  "pages.tenants.title": "Tenants",
  "pages.documents.title": "Documents",
  "pages.reminders.title": "Reminders",
  "pages.contractors.title": "Contractors & suppliers",
  "pages.waitinglist.title": "Candidates and waiting list",
  "tenantPage.title": "Tenants",
  "tenantPage.addButton": "Add tenant",
  "tenantPage.empty": "No tenants added yet.",
  "tenantPage.addFirst": "Add first tenant",
  "tenantPage.timeline": "Timeline",
  "tenantPage.loadError": "Failed to load.",
  "tenantPage.confirmDelete": "Are you sure you want to delete this tenant?",
  "tenantPage.personalInfo": "Personal details",
  "tenantPage.noContact": "No contact details",
  "tenantPage.agreementsTitle": "Rental agreements",
  "tenantPage.noAgreements": "No rental agreements.",
  "tenantPage.tabs.info": "Details",
  "tenantPage.tabs.payments": "Payments",
  "tenantPage.tabs.timeline": "Timeline",
  "tenantPage.tabs.documents": "Documents",
  "tenantPage.tabs.placeDescriptions": "Condition report",
  "tenantPage.tabs.dossier": "Dossier",
  "tenantPage.tabs.actions": "Actions",
  "tenantPage.tabs.welcomePage": "Welcome page",
  "tenantPage.tabs.surveys": "Satisfaction",
  "tenantPage.moreActions": "More actions",
  "tenantPage.portalSectionTitle": "Rentomax account",
  "tenantPage.portalSectionDescription": "Link an existing Rentomax account here or send the invitation to the tenant's email address.",
  "tenantPage.portalActionsUnavailable": "No extra action required",
  "tenantPage.portalLinkAction": "Link Rentomax account",
  "tenantPage.portalLinkConfirm": "Do you want to link the existing Rentomax account for {name} to this tenant?",
  "tenantPage.portalLinkSuccess": "{name} is now linked to Rentomax.",
  "tenantPage.portalLinkError": "The Rentomax link could not be created.",
  "tenantPage.portalLinkUnavailable": "No linkable Rentomax account was found for this tenant.",
  "tenantPage.portalInviteAction": "Invite Rentomax account",
  "tenantPage.portalInviteResendAction": "Resend Rentomax invitation",
  "tenantPage.documentsTabDescription": "Manage tenant documents and upload new files for this tenant.",
  "tenantPage.placeDescriptionsTabDescription": "Open this tenant's condition reports in a separate workspace.",
  "tenantPage.placeDescriptionsTabAction": "Open condition reports",
  "tenantPage.dossierTabDescription": "Export the tenant dossier with the sections you want to include.",
  "tenantPage.dossierTabAction": "Export dossier",
  "tenantPage.portalInviteDialogTitle": "Invite tenant to Rentomax",
  "tenantPage.portalInviteDialogFreeNote": "The email makes it clear that a tenant account on Rentomax is free and stays free.",
  "tenantPage.portalInviteDialogMessageLabel": "Personal message in the email",
  "tenantPage.portalInviteDialogMessagePlaceholder": "Optionally add a short personal note.",
  "tenantPage.portalInviteSending": "Sending invitation...",
  "tenantPage.portalInviteSuccess": "The invitation was sent. Direct link:",
  "tenantPage.portalInviteError": "The invitation could not be sent.",
  "tenantPage.portalInviteUnavailable": "A Rentomax invitation cannot be sent for this tenant right now.",
  "tenantPage.changeRent": "Change rent",
  "tenantPage.noResults": "No tenants found for these filters.",
  "tenantPage.filters.nameLabel": "Name",
  "tenantPage.filters.namePlaceholder": "Search by name",
  "tenantPage.filters.statusLabel": "Status",
  "tenantPage.filters.propertyLabel": "Property",
  "tenantPage.filters.allStatuses": "All statuses",
  "tenantPage.filters.allProperties": "All properties",
  "tenantPage.filters.reset": "Clear filters",
  "placeDescription.buttonShort": "Condition report",
  "placeDescription.title": "Digital condition reports",
  "placeDescription.drawerHelp": "Manage move-in and move-out reports per tenant, with a structured checklist and photos for each item.",
  "placeDescription.add": "Add condition report",
  "placeDescription.loadError": "The condition reports could not be loaded.",
  "placeDescription.empty": "No condition reports for this tenant yet.",
  "placeDescription.exportError": "The PDF could not be generated.",
  "placeDescription.confirmDelete": "Are you sure you want to delete this condition report?",
  "placeDescription.confirmDeletePhoto": "Are you sure you want to delete this photo?",
  "placeDescription.createUnavailable": "Create a rental agreement first before adding a condition report.",
  "placeDescription.templateLabel": "Checklist template",
  "placeDescription.titlePlaceholder": "For example: Move-in condition report",
  "placeDescription.notesPlaceholder": "General notes about the condition, keys, meter readings or arrangements...",
  "placeDescription.editorTitle": "Edit condition report",
  "placeDescription.itemCommentPlaceholder": "Comment for this checklist item",
  "placeDescription.addPhoto": "Add photo",
  "placeDescription.noPhotos": "No photos linked to this item yet.",
  "placeDescription.kind.moveIn": "Move-in",
  "placeDescription.kind.moveOut": "Move-out",
  "placeDescription.condition.good": "Good",
  "placeDescription.condition.needsAttention": "Needs attention",
  "placeDescription.condition.damaged": "Damaged",
  "placeDescription.condition.notApplicable": "Not applicable",
  "placeDescription.stats.sections": "sections",
  "placeDescription.stats.items": "items",
  "placeDescription.stats.photos": "photos",
  "waitinglist.title": "Candidates and waiting list",
  "waitinglist.subtitle": "Pipeline per property from candidate to active tenant.",
  "waitinglist.addButton": "Add candidate",
  "waitinglist.addFirst": "Add first candidate",
  "waitinglist.noPropertiesTitle": "No properties found",
  "waitinglist.noPropertiesBody": "Add a property first before managing candidates.",
  "waitinglist.emptyTitle": "No candidates for this property yet",
  "waitinglist.emptyBody": "Add your first candidate tenant to the pipeline.",
  "waitinglist.pipelineCount": "{count} candidates in pipeline",
  "waitinglist.noCandidates": "No candidates",
  "waitinglist.expiredSection": "Expired ({count})",
  "waitinglist.expiredContract": "Agreement expired",
  "waitinglist.reactivateTitle": "Move back to candidate",
  "waitinglist.reactivateButton": "Candidate again",
  "waitinglist.rejectButton": "Reject",
  "waitinglist.interestDate": "Interest",
  "waitinglist.confirmDelete": "Are you sure you want to delete this candidate?",
  "waitinglist.loadError": "Failed to load.",
  "waitinglist.status.candidate": "Candidate",
  "waitinglist.status.selected": "Selected",
  "waitinglist.status.rejected": "Rejected",
  "waitinglist.status.activeTenant": "Active tenant",
  "pages.profile.title": "My profile",
  "userMenu.profileHint": "Go to My profile",
  "userMenu.accountMode": "Switch account mode",
  "userMenu.accountModeTenantHint": "Tenant mode is active. Open your profile to switch.",
  "userMenu.accountModeLandlordHint": "Landlord mode is active. Open your profile to switch.",
  "userMenu.install": "Install app",
  "userMenu.installHint": "Add Rentomax to your laptop or smartphone",
  "pwa.installIosInstructions": "Open Share and choose 'Add to Home Screen' to install Rentomax.",
  "pwa.installManualInstructions": "Open your browser menu and choose 'Install app' or 'Add to Home Screen'.",
  "pwa.installed": "Rentomax has been added to your device.",
  "pages.tenantActive.title": "Active rental agreements",
  "pages.tenantUpcoming.title": "Upcoming rental agreements",
  "pages.tenantApplications.title": "Applications",
  "pages.tenantHistory.title": "Past rental agreements",
  "pages.onboarding.title": "Welcome to Rentomax",
  "pages.help.title": "Help centre",
  "pages.help.description": "Find answers to your questions about Rentomax.",
  "help.hero.title": "How can we help?",
  "help.hero.subtitle": "Submit your question using the contact form below.",
  "help.resources.title": "Reach the right Rentomax topic faster",
  "help.resources.subtitle": "Use these quick entry points if you mainly want to explore features, compare pricing, or ask a support question right away.",
  "help.resources.features.title": "See what you manage in Rentomax",
  "help.resources.features.body": "Go back to the homepage for an overview of property management, tenants, documents, reminders, place descriptions, and exports.",
  "help.resources.features.button": "Go to features",
  "help.resources.pricing.title": "Compare pricing plans",
  "help.resources.pricing.body": "Open the pricing page if you want to see which plan fits a first property, multiple properties, or a larger rental operation.",
  "help.resources.pricing.button": "View pricing",
  "help.resources.contact.title": "Ask a support question directly",
  "help.resources.contact.body": "Jump straight to the contact form when you need help with onboarding, files, documents, or account questions.",
  "help.resources.contact.button": "Open the form",
  "help.faq.title": "Frequently asked questions",
  "help.faq.intro": "Pick a topic and open only the answer you need.",
  "help.faq.navLabel": "FAQ categories",
  "help.faq.questionCount": "{count} questions",
  "help.faq.categories.gettingStarted.title": "Getting started with Rentomax",
  "help.faq.categories.gettingStarted.description": "Basic setup, first data entry, and a practical rollout order.",
  "help.faq.categories.propertiesTenants.title": "Properties and tenants",
  "help.faq.categories.propertiesTenants.description": "How to organize your portfolio, candidates, tenants, and place descriptions.",
  "help.faq.categories.agreementsDocuments.title": "Agreements and documents",
  "help.faq.categories.agreementsDocuments.description": "What to store per agreement, how to track documents, and what you can export.",
  "help.faq.categories.planningPayments.title": "Planning and follow-up",
  "help.faq.categories.planningPayments.description": "Reminders, events, calendar usage, and manual payment tracking.",
  "help.faq.categories.dataSupport.title": "Working method and support",
  "help.faq.categories.dataSupport.description": "Practical tips to keep your data usable and get help quickly.",
  "help.faq.questions.setup.question": "What is the best way to start with Rentomax?",
  "help.faq.questions.setup.answer": "Start with your profile details, then add your properties and give each property a clear status. Next, add tenants or candidates, link the relevant rental agreements, and upload the key documents. Finally, create reminders and events so your follow-up work appears immediately in your dashboard and calendar.",
  "help.faq.questions.import.question": "Can I bring in existing data instead of entering everything again?",
  "help.faq.questions.import.answer": "Yes. Use onboarding and CSV import to bring over existing properties, tenants, or other core administrative data more quickly. After an import, always review statuses, links, and dates so your overview is reliable from day one.",
  "help.faq.questions.overview.question": "How do I keep my overview useful from the beginning?",
  "help.faq.questions.overview.answer": "Work consistently with fixed statuses, full names, and clear notes. Do not store only the minimum fields; also add key dates, document links, and internal remarks. The more consistent your input is, the more useful your filters, dashboards, and timelines become.",
  "help.faq.questions.countries.question": "Can I use Rentomax for properties in different countries?",
  "help.faq.questions.countries.answer": "Yes. Rentomax is designed for rental administration across multiple countries. You use it to organize properties, tenants, agreements, documents, and follow-up tasks. You should still verify which local arrangements or legal requirements apply to your situation, because Rentomax does not provide legal advice.",
  "help.faq.questions.propertySetup.question": "How should I set up a property?",
  "help.faq.questions.propertySetup.answer": "Create a complete file for each property with address details, status, internal notes, and every document you may need later. Use statuses so you can immediately see whether a property is available, rented, or under follow-up. That makes filtering, planning, and reporting much faster.",
  "help.faq.questions.buildingUnits.question": "How do I work with buildings and units in Rentomax?",
  "help.faq.questions.buildingUnits.answer": "You can manage a building with multiple units while each unit keeps its own file. Shared building information and documents can stay available centrally at the same time.",
  "help.faq.questions.tenantTracking.question": "How do I manage candidates and active tenants clearly?",
  "help.faq.questions.tenantTracking.answer": "Keep candidates and active tenants separate through their status and link them to the correct property. Add contact details, notes, and relevant follow-up points right away. That gives you a quick view of who is still under review, who has been selected, and which tenant is already actively linked to an agreement.",
  "help.faq.questions.welcomePage.question": "What is the tenant welcome page used for?",
  "help.faq.questions.welcomePage.answer": "Use the welcome page to collect practical information for a tenant or file in one place. That can include move-in arrangements, useful documents, shared references, or information you want to keep ready internally. It helps you start a new file in a structured way without scattering context.",
  "help.faq.questions.issueReporting.question": "How do I follow up tenant issue and damage reports?",
  "help.faq.questions.issueReporting.answer": "Active tenants can register problems or damage with photos. You then see those reports in your follow-up per agreement or property.",
  "help.faq.questions.placeDescriptions.question": "How should I use place descriptions, notes, and photos?",
  "help.faq.questions.placeDescriptions.answer": "Use place descriptions to record the condition of a property or room clearly, supported by photos and short notes. Work in a structured way per room or item so you can find things quickly later. The goal is a complete administrative record, not a legal assessment.",
  "help.faq.questions.agreementInfo.question": "What information belongs with a rental agreement in Rentomax?",
  "help.faq.questions.agreementInfo.answer": "For each agreement, store the tenant involved, the linked property, the term, key start and end dates, internal remarks, and supporting documents. Add reminders for renewals, follow-up tasks, or documents that need to be refreshed later. That keeps every agreement connected to the rest of the file.",
  "help.faq.questions.documentFollowUp.question": "How do I track documents and expiry dates efficiently?",
  "help.faq.questions.documentFollowUp.answer": "Upload documents directly to the correct property, tenant, or agreement and create reminders for relevant end dates or review dates. Use clear file names and notes so you know what each document contains later. That turns expiry follow-up into part of your daily overview instead of separate manual searching.",
  "help.faq.questions.pdfDossier.question": "When is PDF export useful?",
  "help.faq.questions.pdfDossier.answer": "PDF export is useful when you want to share a file, archive it internally, or create a snapshot of the available administration. Make sure linked data, documents, and notes are up to date first. Then the export gives you a practical overview without combining multiple screens manually.",
  "help.faq.questions.productBoundary.question": "Does Rentomax provide legal, tax, or compliance advice?",
  "help.faq.questions.productBoundary.answer": "No. Rentomax is an administrative tool for organizing, tracking, and storing information in one place. It helps with overview and timing, but not with legal advice, tax interpretation, legal compliance, or automatic calculations such as rent indexation.",
  "help.faq.questions.remindersEvents.question": "What is the difference between reminders and events?",
  "help.faq.questions.remindersEvents.answer": "Use reminders for items that require active follow-up, such as a document expiry date, a contract milestone, or an internal task. Use events for important dates or happenings that you want to record in the timeline and calendar. Together they give you both action points and history.",
  "help.faq.questions.manualPayments.question": "How does manual rent payment tracking work?",
  "help.faq.questions.manualPayments.answer": "Rentomax lets you register and track payment statuses manually per file. That is useful to see what has been paid, what is still open, or what is under follow-up. The system does not connect to banks or reconcile payments automatically, so use it as an administrative overview alongside your own financial checks.",
  "help.faq.questions.dashboardCalendar.question": "How do I use the dashboard and calendar most efficiently?",
  "help.faq.questions.dashboardCalendar.answer": "Use your dashboard as a daily starting point: review open follow-up work, upcoming deadlines, and recent activity. Use the calendar to plan ahead across all properties and files. Working from those two overviews every day makes it much harder to miss deadlines or loose ends.",
  "help.faq.questions.recurringWorkflow.question": "What is a good routine for recurring follow-up work?",
  "help.faq.questions.recurringWorkflow.answer": "Work in short fixed checks: update new documents, set reminders for future deadlines, register events as soon as they happen, and adjust statuses immediately. That keeps your administration current without needing large correction rounds later.",
  "help.faq.questions.dataQuality.question": "How do I keep my data clean and reliable?",
  "help.faq.questions.dataQuality.answer": "Agree on a fixed way of naming items, setting statuses, titling documents, and writing notes. Avoid duplicate files and update changes immediately instead of trying to remember them later. A well-maintained file per property and tenant makes searching, filtering, and exporting much faster.",
  "help.faq.questions.newOnboarding.question": "How do I add a new property or tenant quickly without forgetting anything?",
  "help.faq.questions.newOnboarding.answer": "Use a fixed checklist: enter the basics, choose the status, add contact details, link documents, record contract details, and set reminders. Following that order helps you build every new file the same way and keeps the overview consistent.",
  "help.faq.questions.timelineUsage.question": "Why is the timeline important in daily work?",
  "help.faq.questions.timelineUsage.answer": "The timeline helps you see what has already happened in a file and which follow-up work came from it. By registering events, notes, and changes consistently, you lose less context when you look back later or pick up a file again.",
  "help.faq.questions.profileManagement.question": "Where do I manage my landlord profile and account settings?",
  "help.faq.questions.profileManagement.answer": "Use My Profile to manage your profile details, account mode, and account access. That keeps your working context and account settings together in one fixed place.",
  "help.faq.questions.helpContact.question": "What should I do if I still cannot find the answer in the FAQ?",
  "help.faq.questions.helpContact.answer": "Use the contact form at the bottom of this page. Briefly explain which property, tenant, or screen your question is about and mention what you have already tried. That context helps support give you a faster and more useful answer.",
  "help.contact.title": "Send us a message",
  "help.success.title": "Message sent!",
  "help.success.body": "We will get back to you as soon as possible.",
  "help.success.reset": "Send another message",
  "help.form.name": "Name",
  "help.form.namePlaceholder": "John Smith",
  "help.form.emailPlaceholder": "john@example.com",
  "help.form.email": "Email address",
  "help.form.subject": "Subject",
  "help.form.subjectPlaceholder": "What is your question about?",
  "help.form.message": "Message",
  "help.form.messagePlaceholder": "Describe your question or issue...",
  "help.form.sending": "Sending...",
  "help.form.submit": "Send message",
  "help.form.error": "Something went wrong. Please try again later.",
  "help.form.networkError": "Could not connect. Please check your internet connection.",
  "dashboard.activeTenants": "Active tenants",
  "dashboard.upcomingDeadlines": "Upcoming deadlines",
  "dashboard.propertyStatuses": "Properties by status",
  "dashboard.buildingOccupancy": "Occupancy per building",
  "dashboard.buildingOccupancyMeta": "{occupied} of {total} units rented",
  "dashboard.noUpcomingDeadlines": "No upcoming deadlines",
  "dashboard.recentEvents": "Recent events",
  "dashboard.noRecentEvents": "No recent events",
  "dashboard.viewAllReminders": "View all reminders",
  "dashboard.viewTenants": "View tenants",
  "calendar.title": "Integrated calendar",
  "calendar.subtitle": "All upcoming dates from reminders, documents, agreements, and events in one read-only overview.",
  "calendar.todayButton": "Today",
  "calendar.viewDay": "Day",
  "calendar.viewWeek": "Week",
  "calendar.filter.all": "All",
  "calendar.highlights.title": "Needs attention",
  "calendar.highlights.subtitle": "The most urgent items in the selected period.",
  "calendar.quickAction.property": "Open property",
  "calendar.quickAction.tenant": "Open tenant",
  "calendar.loadError": "Failed to load the calendar",
  "calendar.empty": "No items in this period.",
  "calendar.summary.total": "Total",
  "calendar.summary.reminders": "Reminders",
  "calendar.summary.documents": "Document expiries",
  "calendar.summary.agreements": "Agreement ends",
  "calendar.summary.events": "Events",
  "calendar.source.reminder": "Reminder",
  "calendar.source.documentExpiry": "Document",
  "calendar.source.agreementEnd": "Agreement",
  "calendar.source.timelineEvent": "Event",
  "calendar.item.agreementEndTitle": "Agreement ends",
  "calendar.item.recurring": "Recurring",
  "property.loadError": "Failed to load properties.",
  "property.deleteError": "The property could not be deleted.",
  "property.cardView": "Card view",
  "property.listView": "List view",
  "property.add": "Add property",
  "property.import": "Import CSV",
  "property.importTitle": "Import properties via CSV",
  "property.importDescription": "Use the same CSV template to move your existing properties and tenants into the platform in one go.",
  "property.importTemplateLink": "Download template.csv",
  "property.importFileLabel": "CSV file",
  "property.importButton": "Start import",
  "property.importHint": "We only create the properties and tenants that fit within your current plan limit. If the file exceeds your limit, the import stops without creating anything.",
  "property.importSuccess": "{propertyCount} properties and {tenantCount} tenants imported.",
  "property.importFileRequired": "Choose the completed CSV file first.",
  "property.importError": "The import failed. Try again with the template file.",
  "property.importRowError": "Row {rowNumber} contains invalid data.",
  "property.addFirst": "Add your first property",
  "property.empty": "No properties added yet.",
  "property.rent": "Rent",
  "property.perMonth": "/month",
  "property.tenantSingular": "tenant",
  "property.tenantPlural": "tenants",
  "property.unitSingular": "unit",
  "property.unitPlural": "units",
  "property.units.title": "Units",
  "property.documentSingular": "document",
  "property.documentPlural": "documents",
  "property.status.rented": "Rented",
  "property.status.vacant": "Vacant",
  "property.status.underRenovation": "Under renovation",
  "property.status.forSale": "For sale",
  "property.type.apartment": "Apartment",
  "property.type.house": "House",
  "property.type.studio": "Studio",
  "property.type.commercial": "Commercial",
  "property.type.garage": "Garage",
  "property.type.other": "Other",
  "property.details.backToOverview": "Back to property overview",
  "property.details.pageTitle": "Property details",
  "property.details.pageSubtitle": "Manage tenants, documents, and follow-up for this property on a dedicated page.",
  "property.details.missingSelection": "Choose a property from the overview first.",
  "property.details.loadError": "Failed to load property details.",
  "property.rentHistory.title": "Rent history",
  "property.rentHistory.subtitle": "Chronological overview of the rent amounts and contract periods already recorded for this property.",
  "property.rentHistory.empty": "No rent history is available for this property yet.",
  "property.rentHistory.records": "records",
  "property.rentHistory.latestRent": "Latest rent",
  "property.rentHistory.ongoing": "ongoing agreement",
  "property.occupancy.title": "Occupancy overview",
  "property.occupancy.subtitle": "Visual timeline of occupied periods, vacancy and tenant changes based on existing contract data.",
  "property.renewals.title": "Contract renewal",
  "property.renewals.subtitle": "Follow expiring agreements proactively and record each follow-up step on the timeline.",
  "property.renewals.empty": "No contracts with an active renewal follow-up for this property yet.",
  "property.renewals.loadError": "Failed to load contract renewal workflows.",
  "property.renewals.updateError": "Failed to update the contract renewal workflow.",
  "property.renewals.endsOn": "Ends on",
  "property.renewals.stage.sixMonths": "Within 6 months",
  "property.renewals.stage.threeMonths": "Within 3 months",
  "property.renewals.step.extendAgreement": "Want to renew? Update the end date",
  "property.renewals.step.extendAgreementHint": "Update the rental agreement. This step completes automatically once the end date changes.",
  "property.renewals.step.contactTenant": "Want to contact the tenant? Log a communication",
  "property.renewals.step.contactTenantHint": "Record that you reached out about the contract renewal.",
  "property.renewals.step.markUpcomingVacancy": "Want to look for a new candidate? Mark as upcoming vacancy",
  "property.renewals.step.markUpcomingVacancyHint": "Record that you plan to put this property back on the market soon.",
  "property.renewals.action.extendAgreement": "Update end date",
  "property.renewals.action.contactTenant": "Log communication",
  "property.renewals.action.markUpcomingVacancy": "Mark upcoming vacancy",
  "property.renewals.contactModalTitle": "Log communication",
  "property.renewals.contactModalNote": "Note",
  "property.renewals.contactModalPlaceholder": "For example: contacted tenant about a possible renewal.",
  "property.occupancy.empty": "No contract history is available for this property yet.",
  "property.occupancy.contractCount": "contracts",
  "property.occupancy.currentlyOccupied": "Currently occupied",
  "property.occupancy.currentlyVacant": "Currently vacant",
  "property.occupancy.summary.rented": "Occupied",
  "property.occupancy.summary.vacant": "Vacancy",
  "property.occupancy.summary.averageLease": "Average lease length",
  "property.occupancy.summary.switches": "Tenant changes",
  "property.occupancy.legend.occupied": "Occupied",
  "property.occupancy.legend.vacant": "Vacancy",
  "property.occupancy.legend.switch": "Change point",
  "property.occupancy.switchesTitle": "Tenant changes",
  "property.occupancy.switchesSubtitle": "Transitions between different tenants for this property.",
  "property.occupancy.noSwitches": "No tenant changes have been recorded from the existing contracts yet.",
  "property.occupancy.switchDirect": "Direct handover",
  "property.occupancy.switchAfterVacancy": "After {{duration}} vacancy",
  "property.occupancy.vacancyLabel": "Vacancy",
  "property.occupancy.occupiedLabel": "Occupied",
  "property.occupancy.until": "until",
  "property.occupancy.duration.none": "0 days",
  "property.occupancy.duration.days": "{{count}} days",
  "property.occupancy.duration.months": "{{count}} mo",
  "property.occupancy.duration.monthsAndDays": "{{months}} mo {{days}} days",
  "property.gallery.title": "Property gallery",
  "property.gallery.helper": "Use these photos when you want to showcase the property later. This storage also counts toward your limit.",
  "property.gallery.upload": "Add photos",
  "property.gallery.empty": "No gallery photos for this property yet.",
  "property.gallery.confirmDelete": "Delete this gallery photo?",
  "property.gallery.previewAlt": "Gallery photo: {{fileName}}",
  "property.gallery.openPreview": "Open gallery photo {{fileName}}",
  "property.gallery.lightboxTitle": "Enlarge gallery photo",
  "property.gallery.closePreview": "Close photo preview",
  "property.gallery.previous": "Previous photo",
  "property.gallery.next": "Next photo",
  "property.gallery.position": "Photo {{current}} of {{total}}",
  "property.publicPage.tabTitle": "Public page",
  "property.publicPage.title": "Public property link",
  "property.publicPage.helper": "Create a public page for this property that you can share with candidate tenants. The link shows the address, type, description and gallery photos.",
  "property.publicPage.status.notConfigured": "Not configured yet",
  "property.publicPage.status.inactive": "Link disabled",
  "property.publicPage.status.active": "Link active",
  "property.publicPage.status.expired": "Link expired",
  "property.publicPage.publicLink": "Public link",
  "property.publicPage.linkUnavailable": "Save the settings first to generate a public link.",
  "property.publicPage.isActiveLabel": "Make the public link reachable",
  "property.publicPage.isActiveHint": "Visitors without an account can open this page while the link is active.",
  "property.publicPage.expiresAt": "Reachable until",
  "property.publicPage.expiresAtHint": "Optional. Leave empty if the link should always stay reachable.",
  "property.publicPage.alwaysAvailable": "Always reachable",
  "property.publicPage.save": "Save settings",
  "property.publicPage.saved": "Public property link saved.",
  "property.publicPage.copySuccess": "Public link copied.",
  "property.publicPage.copyError": "Copying the public link failed.",
  "property.publicPage.clearExpiry": "Clear",
  "property.publicPage.updatedAt": "Last update",
  "property.publicPage.previewTitle": "What visitors will see",
  "property.publicPage.previewDescription": "The public page uses the core property details and the photos from your gallery.",
  "property.publicPage.previewAddress": "Address",
  "property.publicPage.previewType": "Type",
  "property.publicPage.previewStatus": "Status",
  "property.publicPage.previewPhotos": "Gallery photos",
  "property.publicPage.previewNoDescription": "Add a property description to show extra context on the public page.",
  "property.publicPage.loadError": "The public property settings could not be loaded.",
  "property.radar.title": "Expiry radar",
  "property.radar.subtitle": "Visual overview of documents, contracts and open reminders over the next 12 months.",
  "property.radar.empty": "No expiry dates or open reminders found in the next 12 months.",
  "property.radar.contractEnds": "Contract ends",
  "property.radar.upcoming": "Later",
  "property.radar.urgent": "Urgent now",
  "property.radar.noUrgent": "No urgent expiry dates in the next 30 days.",
  "property.radar.timeline": "12 months",
  "property.radar.moreItems": "more items",
  "property.turnovers.title": "Resident switch",
  "property.turnovers.subtitle": "Track move-out and move-in step by step and record each completed step on the timeline.",
  "property.turnovers.addButton": "Start checklist",
  "property.turnovers.empty": "No resident switch checklists for this property yet.",
  "property.turnovers.loadError": "Failed to load resident switch checklists.",
  "property.turnovers.createError": "Failed to create the resident switch checklist.",
  "property.turnovers.updateError": "Failed to update the resident switch checklist.",
  "property.turnovers.deleteError": "Failed to delete the resident switch checklist.",
  "property.turnovers.confirmDelete": "Are you sure you want to delete this resident switch checklist?",
  "property.turnovers.createTitle": "Start resident switch",
  "property.turnovers.titlePlaceholder": "For example: Switch apartment 2A",
  "property.turnovers.completedShort": "done",
  "property.turnovers.completedAt": "Checked on",
  "property.turnovers.exitPhase": "Move-out",
  "property.turnovers.entryPhase": "Move-in",
  "property.turnovers.exitHelp": "Tasks for the departing tenant.",
  "property.turnovers.entryHelp": "Tasks for the incoming tenant.",
  "property.turnovers.exitMissingAgreement": "Link a departing tenant first before checking move-out steps.",
  "property.turnovers.entryMissingAgreement": "Link an incoming tenant first before checking move-in steps.",
  "property.turnovers.outgoingTenantLabel": "Departing tenant",
  "property.turnovers.incomingTenantLabel": "Incoming tenant",
  "property.turnovers.noOutgoingTenant": "Not linked yet",
  "property.turnovers.noIncomingTenant": "Not linked yet",
  "property.turnovers.openPlaceDescription": "Open place description",
  "property.turnovers.step.exitKeysReturned": "Keys returned",
  "property.turnovers.step.exitMeterReadingsRecorded": "Final meter readings recorded",
  "property.turnovers.step.exitPlaceDescriptionCompleted": "Move-out place description completed",
  "property.turnovers.step.exitDepositStatusRecorded": "Deposit status recorded",
  "property.turnovers.step.exitDomicileHandled": "Domicile handling completed",
  "property.turnovers.step.entryKeysHandedOver": "Keys handed over",
  "property.turnovers.step.entryMeterReadingsRecorded": "Initial meter readings recorded",
  "property.turnovers.step.entryPlaceDescriptionCompleted": "Move-in place description completed",
  "property.turnovers.step.entryDepositStatusRecorded": "Deposit status recorded",
  "property.turnovers.step.entryHouseRulesShared": "Tenant informed about house rules",
  "timeline.turnover.exitKeysReturned": "Resident switch: keys returned",
  "timeline.turnover.exitMeterReadingsRecorded": "Resident switch: final meter readings recorded",
  "timeline.turnover.exitPlaceDescriptionCompleted": "Resident switch: move-out place description completed",
  "timeline.turnover.exitDepositStatusRecorded": "Resident switch: move-out deposit status recorded",
  "timeline.turnover.exitDomicileHandled": "Resident switch: domicile handling completed",
  "timeline.turnover.entryKeysHandedOver": "Resident switch: keys handed over",
  "timeline.turnover.entryMeterReadingsRecorded": "Resident switch: initial meter readings recorded",
  "timeline.turnover.entryPlaceDescriptionCompleted": "Resident switch: move-in place description completed",
  "timeline.turnover.entryDepositStatusRecorded": "Resident switch: move-in deposit status recorded",
  "timeline.turnover.entryHouseRulesShared": "Resident switch: tenant informed about house rules",
  "timeline.contractRenewal.extendAgreementCompleted": "Contract renewal: end date updated",
  "timeline.contractRenewal.contactTenantLogged": "Contract renewal: tenant communication logged",
  "timeline.contractRenewal.upcomingVacancyMarked": "Contract renewal: property marked as upcoming vacancy",
  "document.upload": "Upload document",
  "document.type.inspection": "Inspection",
  "document.type.insurance": "Insurance",
  "document.type.invoice": "Invoice",
  "document.type.photo": "Photo",
  "document.type.other": "Other",
  "document.title": "Documents",
  "document.loadError": "Failed to load.",
  "document.all": "All",
  "document.empty": "No documents uploaded yet.",
  "document.emptyFiltered": "No documents of type \"{type}\".",
  "document.uploadFirst": "Upload first document",
  "document.linkProperty": "Link to property",
  "document.linkTenant": "Link to tenant",
  "document.tagsPlaceholder": "e.g. inspection, yearly",
  "document.confirmDelete": "Are you sure you want to delete this document?",
  "document.expired": "Expired",
  "document.expiringSoon": "Soon",
  "document.share": "Share",
  "document.shareTitle": "Share document link",
  "document.shareLink": "Public link",
  "document.shareExpires": "This link remains available until {date}.",
  "document.shareCopied": "Link copied.",
  "document.shareError": "Could not create the link.",
  "document.uploadError": "The document could not be uploaded.",
  "document.storageTitle": "Storage space",
  "document.storageHelp": "Your document and photo storage follows the limit of your current subscription.",
  "document.storageLimitExceeded": "Your storage limit has been reached. Upgrade your subscription to upload more files.",
  "document.storageUpgradeButton": "View upgrade options",
  "document.storageSelectionTooLarge": "This file is about {fileSize}, but you only have {remaining} of storage left.",
  "reminder.add": "Add reminder",
  "reminder.title": "Reminders",
  "reminder.loadError": "Failed to load.",
  "reminder.overdueAlert": "{count} overdue reminder{suffix} - action required.",
  "reminder.emptyOpen": "No open reminders.",
  "reminder.emptyCompleted": "No completed reminders.",
  "reminder.emptyAll": "No reminders created yet.",
  "reminder.complete": "Complete",
  "reminder.new": "New reminder",
  "reminder.linkProperty": "Link to property",
  "reminder.titlePlaceholder": "e.g. renew EPC certificate",
  "reminder.confirmDelete": "Are you sure you want to delete this reminder?",
  "reminder.recurrence": "Recurrence",
  "reminder.noRecurrence": "One-time",
  "reminder.recurring": "Recurring",
  "reminder.recurrenceHint": "Leave the amount empty for a one-time reminder.",
  "reminder.recurrenceSummaryOneTime": "This reminder will be created as a one-time reminder.",
  "reminder.recurrenceSummaryValue": "This reminder repeats: {recurrence}.",
  "reminder.recurrenceDateSummaryMissingDeadline": "Choose a deadline to see the scheduled date.",
  "reminder.recurrenceDateSummaryOneTime": "This reminder takes place on: {date}.",
  "reminder.recurrenceDateSummaryRecurring": "The next reminder after this deadline is on: {date}.",
  "reminder.recurrenceValueLabel": "Every",
  "reminder.recurrenceValuePlaceholder": "Amount",
  "reminder.recurrenceUnit": "Recurrence type",
  "reminder.recurrenceUnitDaySingle": "day",
  "reminder.recurrenceUnitDay": "days",
  "reminder.recurrenceUnitMonthSingle": "month",
  "reminder.recurrenceUnitMonth": "months",
  "reminder.recurrenceUnitYearSingle": "year",
  "reminder.recurrenceUnitYear": "years",
  "reminder.recurrenceEveryDay": "Every day",
  "reminder.recurrenceEveryMonth": "Every month",
  "reminder.recurrenceEveryYear": "Every year",
  "reminder.recurrenceEveryNDays": "Every {count} days",
  "reminder.recurrenceEveryNMonths": "Every {count} months",
  "reminder.recurrenceEveryNYears": "Every {count} years",
  "contractor.title": "Contractors & suppliers",
  "contractor.subtitle": "Keep trusted contacts ready for maintenance, repairs, inspections, and practical follow-up.",
  "contractor.add": "Add contractor",
  "contractor.new": "New contractor",
  "contractor.edit": "Edit contractor",
  "contractor.empty": "No contractors or suppliers added yet.",
  "contractor.emptyFiltered": "No contractors match the current filters.",
  "contractor.loadError": "Failed to load contractors.",
  "contractor.confirmDelete": "Are you sure you want to delete this contractor?",
  "contractor.deleteError": "The contractor could not be deleted.",
  "contractor.trade": "Trade / service",
  "contractor.filter.searchLabel": "Search",
  "contractor.filter.searchPlaceholder": "Search by name, trade, note, email, or phone",
  "contractor.filter.tradeLabel": "Trade",
  "contractor.filter.allTrades": "All trades",
  "contractor.stats.total": "Contacts",
  "contractor.stats.email": "With e-mail",
  "contractor.stats.phone": "With phone",
  "contractor.namePlaceholder": "e.g. John Smith",
  "contractor.tradePlaceholder": "e.g. plumber, electrician, …",
  "contractor.phoneNumberPlaceholder": "e.g. +32 475 12 34 56",
  "contractor.emailPlaceholder": "e.g. info@company.com",
  "contractor.notesPlaceholder": "e.g. Fast, good pricing",
  "profile.notLoggedIn": "You are not logged in.",
  "profile.paymentMethods": "Payment methods",
  "profile.invoices": "Invoices",
  "profile.paymentMethodsSoon": "Payment methods will be available soon.",
  "profile.invoicesSoon": "Invoices will be available soon.",
  "profile.loading": "Loading profile...",
  "profile.name": "Name",
  "profile.providerName": "Name from sign-in provider",
  "profile.displayNameTitle": "Display name",
  "profile.displayNameHelp": "Use your first and last name.",
  "profile.customDisplayName": "Name",
  "profile.loginProvider": "Signed in with",
  "profile.addressDetails": "Address details",
  "profile.addressHelp": "These details are used for your landlord profile.",
  "profile.accountType": "Account type",
  "profile.accountType.private": "Private",
  "profile.accountType.business": "Business",
  "profile.companyName": "Company name",
  "profile.vatNumber": "VAT number",
  "profile.street": "Street",
  "profile.houseNumber": "House number",
  "profile.postalCode": "Postal code",
  "profile.city": "City",
  "profile.country": "Country",
  "profile.countryPlaceholder": "Choose an EU country",
  "profile.billingAddress": "Billing address",
  "profile.billingHelp": "Optional. Only fill this in if your billing address differs from your regular address.",
  "profile.saveButton": "Save profile",
  "profile.saved": "Profile saved.",
  "profile.loadError": "Could not load profile.",
  "profile.saveError": "Could not save profile.",
  "onboarding.displayNameHelp": "Use your first and last name to set up your account.",
  "onboarding.csvTitle": "Import existing properties",
  "onboarding.csvDescription": "Use the CSV template to move your existing properties and tenants in one go. Each row contains a name, address, rent price and start date.",
  "onboarding.csvTemplateLink": "Download template.csv",
  "onboarding.csvFileLabel": "Choose CSV",
  "onboarding.csvImportButton": "Import CSV",
  "onboarding.csvHint": "After a successful import, we skip the manual property and tenant step and continue with onboarding.",
  "billing.loading": "Loading subscription details...",
  "billing.subscriptionTab": "Subscription",
  "billing.invoicesTab": "Invoices",
  "billing.checkoutSuccess": "Your subscription was activated successfully.",
  "billing.checkoutProcessing": "Your payment was received and is still being processed.",
  "billing.processingEyebrow": "Payment processing",
  "billing.processingTitle": "We are updating your subscription",
  "billing.processingBody": "Your payment succeeded. Rentomax is waiting for the payment processing and synchronisation to finish completely.",
  "billing.processingHint": "This page refreshes automatically as soon as your subscription is active or your change has been processed.",
  "billing.checkoutCancelled": "Checkout was cancelled.",
  "billing.checkoutError": "Could not start checkout.",
  "billing.resumeCheckoutTitle": "Preparing your subscription",
  "billing.resumeCheckoutBody": "One moment. We will take you straight to your subscription or to checkout.",
  "billing.portalError": "Could not open the customer portal.",
  "billing.portalLoading": "Opening portal...",
  "billing.noSubscription": "You do not have an active subscription yet.",
  "billing.noSubscriptionTitle": "No active subscription",
  "billing.choosePlan": "Choose a plan",
  "billing.choosePlanHelp": "Select a plan and billing period to continue.",
  "billing.currentPlan": "Current subscription",
  "billing.currentTrialPlan": "Trial",
  "billing.manageHelp": "Cancellation, upgrades, downgrades and payment details are managed through the payment provider customer portal.",
  "billing.manageInAppHelp": "Cancellation, upgrades and downgrades are managed here directly in Rentomax.",
  "billing.planLabel": "Plan",
  "billing.intervalLabel": "Billing",
  "billing.statusLabel": "Status",
  "billing.adminTitle": "Administrator access",
  "billing.adminBody": "Your account has administrator rights. This role does not require a subscription.",
  "billing.adminBadge": "No subscription required",
  "billing.trialTitle": "Free trial",
  "billing.trialBody": "You are using Rentomax temporarily with the same limits as the Starter plan.",
  "billing.trialChoosePlanHelp": "Your trial is still running. Choose a subscription now to keep using Rentomax after the trial.",
  "billing.trialStartedOn": "Started on",
  "billing.trialEndsOn": "Ends on",
  "billing.trialDayRemaining": "day remaining",
  "billing.trialDaysRemaining": "{count} days remaining",
  "billing.propertyLimitSingular": "1 property",
  "billing.propertyLimitPlural": "{count} properties",
  "billing.storageUsed": "Used",
  "billing.storageAvailable": "Storage limit",
  "billing.storageRemaining": "Remaining",
  "billing.storagePlanFeature": "{storage} storage, good for about {count} documents or photos",
  "billing.renewsOn": "Renews on",
  "billing.endsOn": "Ends on",
  "billing.creditBalance": "Credit",
  "billing.cancelScheduled": "Your subscription is scheduled to stop at the end of the current period.",
  "billing.manageSubscription": "Manage subscription",
  "billing.changePlan": "Change subscription",
  "billing.changePlanHelp": "Upgrades start immediately after payment. Downgrades are scheduled for the next billing period.",
  "billing.changeTerms.title": "Subscription change terms",
  "billing.changeTerms.linkLabel": "Click here to read the subscription change terms",
  "billing.changeTerms.consentLabel": "I have read the subscription change terms and agree to them before changing my subscription.",
  "consent.eyebrow": "Privacy",
  "consent.title": "Choose how Rentomax uses storage on this device",
  "consent.description": "Rentomax uses cookies and local storage for language choice, session security and a smooth experience on public and signed-in pages.",
  "consent.actions.necessary": "Necessary only",
  "consent.actions.all": "Accept all",
  "consent.saved.pending": "Your choice will be stored on this device once you select an option.",
  "consent.saved.necessary": "Your choice for necessary storage only has been stored on this device.",
  "consent.saved.all": "Your choice to allow all storage has been stored on this device.",
  "billing.changeTerms.validationError": "Please confirm that you have read the subscription change terms before choosing a subscription.",
  "billing.changeTerms.intro": "When you change your subscription, the following settlement rules apply to the remainder of the paid billing period.",
  "billing.changeTerms.downgrade": "A downgrade to a lower plan or lower-priced formula takes effect at the end of your current paid billing period. Your current subscription remains active until then and amounts already paid are not refunded mid-period.",
  "billing.changeTerms.upgrade": "An upgrade to a higher plan or a different formula takes effect immediately. The remaining value of your current period is applied pro rata as credit toward upcoming payments.",
  "billing.cancelSubscription": "Cancel subscription",
  "billing.cancelConfirm": "Are you sure you want to cancel your subscription?",
  "billing.coolingOffTrialStartedTitle": "Your free trial has started",
  "billing.coolingOffTrialStartedBody": "Your subscription was cancelled and you are now switched to a free 14-day trial.",
  "billing.coolingOffProfileOnlyTitle": "Your subscription was cancelled",
  "billing.coolingOffProfileOnlyBody": "Your subscription was cancelled. You no longer have a free trial available and now only have access to this profile page.",
  "billing.subscriptionUpdated": "Your subscription change was processed.",
  "billing.subscriptionUpdatedImmediate": "Your subscription was updated immediately.",
  "billing.subscriptionUpdatedScheduled": "Your subscription change was scheduled for the next billing period.",
  "billing.subscriptionUpdateError": "Your subscription could not be changed.",
  "billing.subscriptionCancelled": "Your subscription was cancelled.",
  "billing.subscriptionCancelError": "Your subscription could not be cancelled.",
  "billing.subscriptionActionLoading": "Working...",
  "billing.currentSelection": "Current selection",
  "billing.pendingChangeTitle": "Scheduled change",
  "billing.pendingChangeBody": "Your subscription changes to {plan} ({interval}) on {date}.",
  "billing.pendingChangeBodyAfterPayment": "Your subscription changes to {plan} ({interval}) as soon as your payment is confirmed.",
  "billing.comparePlans": "Compare plans",
  "billing.invoiceHistory": "Invoice history",
  "billing.invoiceHelp": "Open your invoices here as soon as they are available.",
  "billing.noInvoices": "No invoices are available yet.",
  "billing.invoiceLabel": "Invoice",
  "billing.creditNoteLabel": "Credit note",
  "billing.invoiceFallbackTitle": "Invoice",
  "billing.viewInvoice": "View invoice",
  "billing.manageExistingSubscription": "You already have an active subscription. Manage upgrades and downgrades from your profile page.",
  "billing.status.active": "Active",
  "billing.status.trialing": "Trialing",
  "billing.status.pastDue": "Past due",
  "billing.status.canceled": "Canceled",
  "billing.status.unpaid": "Unpaid",
  "billing.status.incomplete": "Incomplete",
  "billing.status.incompleteExpired": "Expired",
  "billing.status.pending": "Processing",
  "billing.status.failed": "Failed",
  "billing.status.expired": "Expired",
  "billing.status.paid": "Paid",
  "billing.status.open": "Open",
  "billing.status.draft": "Draft",
  "billing.status.void": "Voided",
  "trialNotice.title": "Your free trial has started",
  "trialNotice.subtitle": "You can now use Rentomax free for 14 days.",
  "trialNotice.body": "During your trial, you have the same options as the Starter plan. You can choose a subscription later from your profile.",
  "trialNotice.confirm": "Got it",
  "property.limit.title": "You have reached your subscription limit",
  "property.limit.error": "Your subscription does not allow more properties.",
  "property.limit.description.single": "Your current subscription allows up to {count} property.",
  "property.limit.description.multi": "Your current subscription allows up to {count} properties.",
  "property.limit.description.singleWithPlan": "Your current subscription allows up to {count} property. Upgrade to {plan} to add more properties.",
  "property.limit.description.multiWithPlan": "Your current subscription allows up to {count} properties. Upgrade to {plan} to add more properties.",
  "property.limit.upgradeButton": "View upgrade options",
  "event.moveIn": "Move-in",
  "event.moveOut": "Move-out",
  "event.damage": "Damage",
  "event.inspection": "Inspection",
  "event.indexation": "Indexation",
  "event.propertyStatusChange": "Property status",
  "event.remark": "Remark",
  "confirm.title": "Confirmation",
  "timeline.add": "Add event",
  "timeline.empty": "No events recorded yet.",
  "timeline.newEvent": "New event",
  "timeline.titlePlaceholder": "Describe the event briefly",
  "timeline.descriptionPlaceholder": "Optional additional details...",
  "timeline.saving": "Working...",
  "timeline.loadError": "Failed to load the timeline.",
  "tenantPayments.sectionTitle": "Rent payments",
  "tenantPayments.empty": "No rental agreements with payment months are available yet.",
  "tenantPayments.unavailable": "Failed to load the payment log.",
  "tenantPayments.modalTitle": "Track rent payment",
  "tenantPayments.statusLabel": "Status",
  "tenantPayments.clearStatus": "Not filled in",
  "tenantPayments.paidOn": "Paid on",
  "tenantPayments.note": "Note",
  "tenantPayments.notePlaceholder": "For example: 3 days late or partly paid",
  "tenantPayments.saveError": "Failed to save the rent payment.",
  "tenantPayments.status.paid": "Paid",
  "tenantPayments.status.unpaid": "Unpaid",
  "tenantPayments.status.unmarked": "Open",
  "dossier.buttonShort": "Dossier",
  "dossier.property.modalTitle": "Export landlord dossier",
  "dossier.property.modalDescription": "Choose which sections to include in the PDF bundle for this property.",
  "dossier.property.section.summary": "Property overview",
  "dossier.property.section.tenants": "Tenants and contact details",
  "dossier.property.section.documents": "Document overview",
  "dossier.property.section.reminders": "Reminders",
  "dossier.tenant.modalTitle": "Export tenant dossier",
  "dossier.tenant.modalDescription": "Choose which sections to include in the PDF bundle for this tenant.",
  "dossier.tenant.section.contact": "Contact details",
  "dossier.tenant.section.agreements": "Rental agreements",
  "dossier.tenant.section.documents": "Documents",
  "dossier.tenant.section.timeline": "Timeline",
  "dossier.tenant.section.reminders": "Related reminders",
  "dossier.error.emptySelection": "Select at least one section for the export.",
  "dossier.error.exportFailed": "The PDF could not be generated.",
  "nav.admin": "Admin",
  "pages.admin.title": "Admin",
  "pages.admin.description": "Manage users and application errors in Rentomax.",
  "admin.loadError": "Error loading users.",
  "admin.accessDenied": "Access denied. Admin rights required.",
  "admin.subtitle": "Manage users and inspect logged application errors.",
  "admin.tab.users": "Users",
  "admin.tab.plans": "Plans",
  "admin.tab.invoices": "Invoices",
  "admin.tab.creditNotes": "Credit notes",
  "admin.tab.revenue": "Revenue",
  "admin.tab.errors": "Errors",
  "admin.billingPlans.title": "Manage subscription plans",
  "admin.billingPlans.subtitle": "Adjust the price, property limit, and storage limit for each plan. Adding or removing plans is not available here.",
  "admin.billingPlans.monthlyPrice": "Monthly price (EUR)",
  "admin.billingPlans.yearlyPrice": "Yearly price (EUR)",
  "admin.billingPlans.priceExcludingVat": "excl. 21% VAT: {amount}",
  "admin.billingPlans.propertyLimit": "Property limit",
  "admin.billingPlans.storageLimitGb": "Storage limit (GB)",
  "admin.billingPlans.save": "Save",
  "admin.billingPlans.loadError": "The subscription plan configuration could not be loaded.",
  "admin.billingPlans.saveError": "The subscription plan configuration could not be saved.",
  "admin.platformReset.openButton": "Reset platform",
  "admin.platformReset.dialogTitle": "Reset platform",
  "admin.platformReset.dialogSubtitle": "Delete all platform data except the admin@rentomax.be account and every record linked to that account.",
  "admin.platformReset.warningTitle": "Warning: this reset returns the platform to a clean state.",
  "admin.platformReset.warningIntro": "After confirmation, all other users, properties, tenants, subscriptions, invoices, logs, and linked storage files will be deleted permanently.",
  "admin.platformReset.consequenceData": "All database records for other accounts will be removed from every linked table.",
  "admin.platformReset.consequenceFiles": "All linked documents, photos, invoices, and credit notes in storage will be deleted as well.",
  "admin.platformReset.consequencePreserved": "Only admin@rentomax.be and every linked record for that account will remain.",
  "admin.platformReset.consequenceIrreversible": "Once confirmed, this reset cannot be undone.",
  "admin.platformReset.confirmationLabel": "Type rentomax to confirm",
  "admin.platformReset.confirmationPlaceholder": "rentomax",
  "admin.platformReset.confirmationHelp": "The confirm button only becomes active when you enter rentomax exactly.",
  "admin.platformReset.confirmationMismatch": "Type rentomax exactly to confirm the reset.",
  "admin.platformReset.confirmLabel": "Reset platform",
  "admin.platformReset.resetError": "The platform could not be reset.",
  "admin.newUserAccess.sectionTitle": "New user access",
  "admin.newUserAccess.sectionDescription": "Control whether new accounts may still sign up. Existing accounts keep their access.",
  "admin.newUserAccess.enabled": "New users allowed",
  "admin.newUserAccess.disabled": "New users blocked",
  "admin.newUserAccess.toggleLabel": "On/off",
  "admin.newUserAccess.saveError": "The new user access setting could not be saved.",
  "admin.googleLogin.sectionTitle": "Google sign-in",
  "admin.googleLogin.sectionDescription": "Control whether visitors may still sign in or create an account through Google. The login page button follows this setting immediately.",
  "admin.googleLogin.enabled": "Google sign-in enabled",
  "admin.googleLogin.disabled": "Google sign-in disabled",
  "admin.googleLogin.toggleLabel": "On/off",
  "admin.googleLogin.saveError": "The Google sign-in setting could not be saved.",
  "admin.microsoftLogin.sectionTitle": "Microsoft sign-in",
  "admin.microsoftLogin.sectionDescription": "Control whether visitors may still sign in or create an account through Microsoft. The login page button follows this setting immediately.",
  "admin.microsoftLogin.enabled": "Microsoft sign-in enabled",
  "admin.microsoftLogin.disabled": "Microsoft sign-in disabled",
  "admin.microsoftLogin.toggleLabel": "On/off",
  "admin.microsoftLogin.saveError": "The Microsoft sign-in setting could not be saved.",
  "admin.userCount": "{count} users",
  "admin.col.provider": "Provider",
  "admin.col.effectiveDisplayName": "Name",
  "admin.col.email": "Email",
  "admin.col.id": "Id",
  "admin.col.externalId": "ExternalId",
  "admin.col.createdAt": "Created",
  "admin.col.lastLoggedIn": "Last logged in",
  "admin.col.blocked": "Status",
  "admin.col.onboarding": "Onboarding",
  "admin.col.business": "Business",
  "admin.col.role": "Role",
  "admin.active": "Active",
  "admin.blocked": "Blocked",
  "admin.completed": "Completed",
  "admin.notCompleted": "Not completed",
  "admin.yes": "Yes",
  "admin.no": "No",
  "admin.role.admin": "Admin",
  "admin.role.landlord": "Landlord",
  "admin.viewDetails": "View details",
  "admin.filter.email": "Email",
  "admin.filter.name": "Name",
  "admin.filter.namePlaceholder": "Search by name",
  "admin.filter.emailPlaceholder": "Search by email",
  "admin.filter.id": "Id",
  "admin.filter.idPlaceholder": "Search by id or externalId",
  "admin.filter.business": "Business",
  "admin.filter.onboarding": "Onboarding",
  "admin.filter.all": "All",
  "admin.filter.apply": "Apply filters",
  "admin.filter.reset": "Reset",
  "admin.noResults": "No users found.",
  "admin.billingDocuments.count": "{count} documents",
  "admin.billingDocuments.col.number": "Number",
  "admin.billingDocuments.col.firstName": "First name",
  "admin.billingDocuments.col.lastName": "Last name",
  "admin.billingDocuments.col.amount": "Amount",
  "admin.billingDocuments.col.date": "Date",
  "admin.invoices.loadError": "Error loading invoices.",
  "admin.invoices.title": "Platform invoices",
  "admin.invoices.subtitle": "Overview of every invoice in the platform, with a download action on each row.",
  "admin.invoices.empty": "No invoices found.",
  "admin.creditNotes.loadError": "Error loading credit notes.",
  "admin.creditNotes.title": "Platform credit notes",
  "admin.creditNotes.subtitle": "Overview of every credit note in the platform, with a download action on each row.",
  "admin.creditNotes.empty": "No credit notes found.",
  "admin.revenue.loadError": "Error loading the revenue overview.",
  "admin.revenue.title": "Realized revenue per calendar year",
  "admin.revenue.subtitle": "Net overview of paid invoices and credit notes starting from calendar year 2026.",
  "admin.revenue.empty": "No revenue data found.",
  "admin.revenue.totalLabel": "Total since 2026",
  "admin.revenue.yearsTrackedLabel": "Calendar years in overview",
  "admin.revenue.col.year": "Year",
  "admin.revenue.col.amount": "Revenue",
  "admin.revenue.col.invoices": "Invoices",
  "admin.revenue.col.creditNotes": "Credit notes",
  "admin.errors.loadError": "Error loading application errors.",
  "admin.errors.count": "{count} errors",
  "admin.errors.noResults": "No application errors found.",
  "admin.errors.viewDetails": "View error details",
  "admin.errors.delete": "Delete error",
  "admin.errors.confirmDelete": "Are you sure you want to delete this application error?",
  "admin.errors.deleteSuccess": "Application error deleted.",
  "admin.errors.deleteError": "Could not delete the application error.",
  "admin.errors.filter.functionName": "Function",
  "admin.errors.filter.functionNamePlaceholder": "Search by function name",
  "admin.errors.filter.path": "Path",
  "admin.errors.filter.pathPlaceholder": "Search by endpoint path",
  "admin.errors.filter.method": "Method",
  "admin.errors.filter.userId": "User ID",
  "admin.errors.filter.userIdPlaceholder": "Search by user id",
  "admin.errors.filter.search": "Free search",
  "admin.errors.filter.searchPlaceholder": "Search in message, stack trace, metadata...",
  "admin.errors.filter.statusCode": "Status code",
  "admin.errors.filter.occurredFrom": "From date",
  "admin.errors.filter.occurredTo": "To date",
  "admin.errors.col.occurredAt": "Occurred at",
  "admin.errors.col.statusCode": "Status",
  "admin.errors.col.method": "Method",
  "admin.errors.col.path": "Path",
  "admin.errors.col.functionName": "Function",
  "admin.errors.col.exceptionType": "Exception type",
  "admin.errors.col.message": "Message",
  "admin.errors.col.userId": "User ID",
  "admin.errors.col.invocationId": "Invocation ID",
  "admin.errors.col.stackTrace": "Stack trace",
  "admin.errors.col.metadata": "Metadata",
  "admin.pagination.summary": "{start}-{end} of {total}",
  "admin.pagination.page": "Page {page} of {totalPages}",
  "admin.pagination.previous": "Previous",
  "admin.pagination.next": "Next",
  "admin.pagination.noResults": "0 results",
  "admin.subscription.currentSummary": "Current subscription details",
  "admin.subscription.currentPlan": "Plan",
  "admin.subscription.provider": "Billing source",
  "admin.subscription.customerId": "Provider customer ID",
  "admin.subscription.status": "Status",
  "admin.subscription.startsAt": "Starts",
  "admin.subscription.endsAt": "Ends",
  "admin.subscription.none": "None",
  "admin.subscription.formTitle": "Adjust subscription manually",
  "admin.subscription.formDescription": "Set a subscription period for this account without payment. Accounts with a provider-managed subscription must first be stopped or expired.",
  "admin.subscription.plan": "Subscription",
  "admin.subscription.interval": "Interval",
  "admin.subscription.interval.monthly": "Monthly",
  "admin.subscription.interval.yearly": "Yearly",
  "admin.subscription.startDate": "Start date",
  "admin.subscription.endDate": "End date",
  "admin.subscription.noPlans": "There are currently no subscription plans available to choose from.",
  "admin.subscription.loadPlansError": "Subscription options could not be loaded.",
  "admin.subscription.saveError": "The subscription change could not be saved.",
  "admin.subscription.periodError": "The end date must be after the start date.",
  "admin.subscription.required": "Complete all subscription fields.",
  "admin.subscription.protectedTitle": "Admin account subscription is protected",
  "admin.subscription.protectedBody": "Users with the Admin role cannot receive a manual subscription from the admin screen.",
  "admin.subscription.status.active": "Active",
  "admin.subscription.status.pastDue": "Past due",
  "admin.subscription.status.canceled": "Canceled",
  "admin.subscription.status.trialing": "Trial",
  "admin.subscription.startAccess": "New paid starts",
  "admin.subscription.startAllowed": "Allowed",
  "admin.subscription.startBlocked": "Blocked",
  "admin.userDelete.sectionTitle": "Delete user permanently",
  "admin.userDelete.sectionDescription": "Only remove this user when the full account and all linked records may be erased permanently.",
  "admin.userDelete.openButton": "Delete user",
  "admin.userDelete.dialogTitle": "Delete user permanently",
  "admin.userDelete.warningTitle": "Warning: this action cannot be undone.",
  "admin.userDelete.warningIntro": "You are about to permanently delete the account for {email}.",
  "admin.userDelete.consequenceData": "All data for this user will be removed from the admin area and every linked table.",
  "admin.userDelete.consequenceFiles": "All linked files such as photos, documents, and invoice files will be deleted as well.",
  "admin.userDelete.consequenceBilling": "Active provider-managed subscriptions are stopped first so no further charges are created.",
  "admin.userDelete.consequenceIrreversible": "Once confirmed, this user cannot be restored.",
  "admin.userDelete.confirmLabel": "Delete permanently",
  "admin.userDelete.deleteError": "The user could not be deleted.",
  "admin.userBlock.sectionTitle": "Block access",
  "admin.userBlock.sectionDescription": "Block this account to stop future sign-ins and API access immediately.",
  "admin.userBlock.blockButton": "Block user",
  "admin.userBlock.unblockButton": "Unblock user",
  "admin.userBlock.dialogTitleBlock": "Block user",
  "admin.userBlock.dialogTitleUnblock": "Unblock user",
  "admin.userBlock.warningTitleBlock": "This user loses access immediately.",
  "admin.userBlock.warningTitleUnblock": "This user regains access.",
  "admin.userBlock.warningIntroBlock": "After confirmation, the user will see that the account is blocked and that they need to contact the helpdesk.",
  "admin.userBlock.warningIntroUnblock": "After confirmation, the user can sign in again with the existing account.",
  "admin.userBlock.confirmBlock": "Block",
  "admin.userBlock.confirmUnblock": "Unblock",
  "admin.userBlock.saveError": "The block status could not be saved.",
  "admin.bulkSubscription.cancelSelected": "Stop selected subscriptions",
  "admin.bulkSubscription.cancelAllPaid": "Stop all paid subscriptions",
  "admin.bulkSubscription.dialogTitleSelected": "Stop selected subscriptions",
  "admin.bulkSubscription.dialogSubtitleSelected": "{count} user(s) will be stopped immediately, refunded pro rata, and blocked from starting a new paid subscription.",
  "admin.bulkSubscription.dialogTitleAllPaid": "Stop all paid subscriptions",
  "admin.bulkSubscription.dialogSubtitleAllPaid": "This action applies to every user with a paid subscription across the full Rentomax platform.",
  "admin.bulkSubscription.warningTitle": "This action stops subscriptions immediately.",
  "admin.bulkSubscription.warningBodySelected": "After confirmation, future renewals stop immediately, the remaining paid period is refunded pro rata, and these accounts cannot start a new paid subscription anymore.",
  "admin.bulkSubscription.warningBodyAllPaid": "After confirmation, future renewals stop immediately across the platform, the remaining paid period is refunded pro rata, and these accounts cannot start a new paid subscription anymore.",
  "admin.bulkSubscription.confirmSelected": "Stop selection",
  "admin.bulkSubscription.confirmAllPaid": "Stop all",
  "admin.bulkSubscription.confirmationLabel": "Type rentomax to confirm",
  "admin.bulkSubscription.confirmationPlaceholder": "rentomax",
  "admin.bulkSubscription.confirmationHelp": "The confirm button only becomes active when you type exactly rentomax.",
  "admin.bulkSubscription.confirmationMismatch": "Type exactly rentomax to confirm this action.",
  "admin.bulkSubscription.saveError": "The bulk subscription stop could not be completed.",
  "admin.protectedAccount.title": "Protected admin account",
  "admin.protectedAccount.body": "Users with the Admin role cannot receive a manual subscription, be blocked, or be deleted.",
  "nav.contracts": "Timeline",
  "pages.contracts.title": "Contracts timeline",
  "contractTimeline.title": "Contracts timeline",
  "contractTimeline.subtitle": "Visual overview of all rental contracts per property",
  "contractTimeline.today": "Today",
  "contractTimeline.openEnded": "no end date",
  "contractTimeline.vacant": "Vacant",
  "contractTimeline.noProperties": "You haven't added any properties yet.",
  "contractTimeline.addProperty": "Add property",
  "contractTimeline.loadError": "Error loading timeline",
  "contractTimeline.legend.active": "Active",
  "contractTimeline.legend.endingSoon": "Ending within 3 months",
  "contractTimeline.legend.ended": "Ended",
  "contractTimeline.legend.inactive": "Inactive",
  "contractTimeline.legend.vacant": "Vacant / no contract",
  "notifications.triggerAriaLabel": "Open notifications",
  "notifications.title": "Notifications",
  "notifications.unreadCount": "{count} unread",
  "notifications.markAllRead": "Mark all as read",
  "notifications.deleteAllAriaLabel": "Delete all notifications",
  "notifications.deleteSingleAriaLabel": "Delete notification",
  "notifications.confirmDeleteSingle": "Do you want to delete this notification?",
  "notifications.confirmDeleteAll": "Do you want to delete all notifications?",
  "notifications.hiddenUnreadCount": "{count} older unread notifications remain",
  "notifications.showAllUnread": "Show all unread",
  "notifications.showFewerUnread": "Show fewer",
  "notifications.readSection": "Recently read",
  "notifications.empty": "No notifications yet.",
  "notifications.loadError": "Notifications could not be loaded.",
  "notifications.generic.title": "New update",
  "notifications.generic.message": "Open the notification to view the details.",
  "notifications.tenantApplicationAssigned.title": "New application",
  "notifications.tenantApplicationAssigned.message": "{propertyAddress} was added to your tenant portal as an application.",
  "notifications.tenantAgreementAssigned.title": "New rental agreement",
  "notifications.tenantAgreementAssigned.message": "{propertyAddress} was added to your tenant portal.",
  "notifications.tenantAgreementUpdated.title": "Rental agreement updated",
  "notifications.tenantAgreementUpdated.message": "There are new details for {propertyAddress}. Open the agreement to review them.",
  "notifications.tenantAgreementEndingSoon.title": "Rental agreement ending soon",
  "notifications.tenantAgreementEndingSoon.message": "Your rental agreement for {propertyAddress} ends on {endDate}.",
  "notifications.reminderOverdue.title": "Reminder overdue",
  "notifications.reminderOverdue.message": "{title} became overdue on {dueDate}.",
  "notifications.surveyResponse.title": "Survey completed",
  "notifications.surveyResponse.message": "{tenantName} completed the satisfaction survey for {year}.",
  "notifications.damageReportCreated.title": "New damage report",
  "notifications.damageReportCreated.message": "{tenantName} reported an issue for {propertyAddress}.",
  "survey.sectionTitle": "Satisfaction survey",
  "survey.sendButton": "Send survey",
  "survey.resendButton": "Send again",
  "survey.sending": "Sending...",
  "survey.sendSuccess": "Survey sent",
  "survey.sendError": "Sending failed",
  "survey.alreadySentThisYear": "Already sent this year",
  "survey.onlyLatestAgreementYear": "Only in the latest active rental year",
  "survey.noEmail": "Tenant has no email address",
  "survey.noEmailHint": "It is not possible to send a survey when the tenant's email address is not available.",
  "survey.rating": "Rating",
  "survey.comment": "Comment",
  "survey.answered": "Answered",
  "survey.pending": "Awaiting response",
  "survey.year": "Year",
  "survey.noResults": "No surveys sent yet",
  "survey.stars": "stars",
  "common.rentAmount": "Rent",
  "common.rentAmountPerMonth": "Rent amount (EUR/month)",
  "common.rentAmountPlaceholder": "e.g. 850.00",
  "tenant.form.lastName": "Last name",
  "tenant.form.addTitle": "New tenant",
  "tenant.form.editTitle": "Edit tenant",
  "tenant.form.currentlyRunning": "current",
  "agreement.editTitle": "Edit rental agreement",
  "agreement.updateError": "The rental agreement could not be updated.",
  "agreement.rentChange.title": "Change rent",
  "agreement.rentChange.error": "The rent change could not be saved.",
  "agreement.rentChange.currentEndDate": "End date current agreement",
  "agreement.rentChange.newStartDate": "Start date new agreement",
  "property.addressPlaceholder": "Street 1, 1000 City",
  "property.form.structureType": "Structure",
  "property.form.name": "Name",
  "property.form.namePlaceholder": "For example Parkzicht Residence",
  "property.form.unitLabel": "Unit label",
  "property.form.unitLabelPlaceholder": "For example 1A",
  "property.form.units": "Units",
  "property.form.unitsPlaceholder": "1A\n1B\n2A",
  "property.form.unitsHint": "Add one unit label per line. Each unit gets its own dossier.",
  "property.structure.standalone": "Standalone property",
  "property.structure.building": "Building with units",
  "property.structure.unit": "Unit",
  "property.descriptionPlaceholder": "Optional description...",
  "property.notifications.sectionTitle": "Property notification preferences",
  "property.notifications.sectionDescription": "Choose per reminder type whether you want an alert and how far in advance it should appear.",
  "property.notifications.leadTimeLabel": "Lead time for {label}",
  "property.notifications.unit.days": "days",
  "property.notifications.unit.months": "months",
  "property.notifications.contractEnd.label": "Contract end",
  "property.notifications.contractEnd.hint": "Warn before an active rental agreement reaches its end date.",
  "property.notifications.epcExpiry.label": "EPC expiry",
  "property.notifications.epcExpiry.hint": "Warn before the linked EPC document expires.",
  "property.notifications.insuranceExpiry.label": "Insurance",
  "property.notifications.insuranceExpiry.hint": "Warn before an insurance document expires.",
  "property.form.addTitle": "New property",
  "property.form.editTitle": "Edit property",
  "property.form.linkTenantTitle": "Link existing tenant",
  "property.form.noAvailableTenants": "No available tenants to link.",
  "property.form.linkTenantButton": "Link tenant",
  "property.form.documentTypeLabel": "Document type",
  "property.form.addTenantError": "The tenant could not be added.",
  "property.form.linkTenantError": "The tenant could not be linked.",
  "property.form.reminderError": "The reminder could not be saved.",
  "waitinglist.form.addTitle": "New candidate",
  "waitinglist.form.editTitle": "Edit candidate",
  "waitinglist.form.personLabel": "Person",
  "waitinglist.form.personModeNewTitle": "New person",
  "waitinglist.form.personModeNewDescription": "Add a candidate with new contact details.",
  "waitinglist.form.personModeExistingTitle": "Known person",
  "waitinglist.form.personModeExistingDescription": "Choose someone already stored in Rentomax.",
  "waitinglist.form.selectPerson": "Select person",
  "waitinglist.form.selectPlaceholder": "-- Select --",
  "waitinglist.form.loadingKnownPersons": "Loading known people...",
  "waitinglist.form.noKnownPersons": "No known people",
  "waitinglist.form.rentomaxLookupHint": "Add an email address to check whether this candidate already has a Rentomax account.",
  "waitinglist.form.rentomaxLookupLoading": "Checking the Rentomax account...",
  "waitinglist.form.rentomaxLookupError": "The Rentomax account could not be checked. You can continue without linking.",
  "waitinglist.form.rentomaxKnownAccount": "This candidate already has a Rentomax account through {provider}.",
  "waitinglist.form.rentomaxNoAccount": "This candidate does not have a Rentomax account yet. You can send a free invitation, and sign-in is available by email, Google, or Microsoft.",
  "waitinglist.form.rentomaxActionLabel": "Rentomax link",
  "waitinglist.form.rentomaxAction.noneTitle": "Do not link",
  "waitinglist.form.rentomaxAction.noneDescriptionKnown": "Keep this candidate for the landlord only. The candidate sees nothing in the tenant portal.",
  "waitinglist.form.rentomaxAction.noneDescriptionUnknown": "Keep this candidate for the landlord only, without sending a Rentomax invitation.",
  "waitinglist.form.rentomaxAction.linkTitle": "Link existing Rentomax account",
  "waitinglist.form.rentomaxAction.linkDescription": "Show the application in the tenant portal immediately and send a Rentomax notification.",
  "waitinglist.form.rentomaxAction.inviteTitle": "Invite a free Rentomax account",
  "waitinglist.form.rentomaxAction.inviteDescription": "Send a free invitation. Account creation is available by email, Google, or Microsoft.",
  "waitinglist.form.interestDateLabel": "Interest date",
  "waitinglist.form.notesPlaceholder": "Details, remarks...",
  "waitinglist.form.convertTitle": "Convert to {status}",
  "waitinglist.form.convertDescription": "The candidate will be converted into an active tenant. Set the rental terms below. After conversion the candidate card can no longer be edited.",
  "waitinglist.form.convertSubmit": "Convert to {status}",
  "waitinglist.inviteButton": "Invite",
  "waitinglist.inviteResendButton": "Send again",
  "waitinglist.inviteSentLabel": "Invitation sent",
  "waitinglist.inviteDialogTitle": "Invite candidate tenant",
  "waitinglist.inviteDialogFreeNote": "The email explains clearly that a tenant account on Rentomax is free and will remain free.",
  "waitinglist.inviteDialogMessageLabel": "Personal message for the email",
  "waitinglist.inviteDialogMessagePlaceholder": "Optionally add a short personal message.",
  "waitinglist.inviteSend": "Send invitation",
  "waitinglist.inviteSending": "Sending invitation...",
  "waitinglist.inviteSuccess": "The invitation was sent. Direct link:",
  "waitinglist.inviteError": "The invitation could not be sent.",
  "waitinglist.portalStatus.has-account-unlinked.label": "Rentomax known, not linked",
  "waitinglist.portalStatus.has-account-unlinked.tooltip": "The candidate already has a Rentomax account, but it is not linked to this application yet.",
  "waitinglist.portalStatus.no-account-unlinked.label": "No Rentomax, no link",
  "waitinglist.portalStatus.no-account-unlinked.tooltip": "The candidate does not have a Rentomax account yet and no link or invitation exists.",
  "waitinglist.portalStatus.has-account-linked.label": "Rentomax linked",
  "waitinglist.portalStatus.has-account-linked.tooltip": "The candidate has a Rentomax account and it is linked to this application.",
  "waitinglist.portalStatus.no-account-invite-sent.label": "Invitation sent",
  "waitinglist.portalStatus.no-account-invite-sent.tooltip": "The candidate does not have a Rentomax account yet. A free invitation was already sent to sign in by email, Google, or Microsoft.",
  "waitinglist.form.saveError": "The candidate could not be saved.",
  "waitinglist.form.convertError": "The candidate could not be converted.",
  "waitinglist.deleteError": "The candidate could not be deleted.",
  "timeline.confirmDelete": "Are you sure you want to delete this event?",
  "onboarding.step.profile": "Profile",
  "onboarding.step.property": "Property",
  "onboarding.step.tenant": "Tenant",
  "onboarding.step.document": "Document",
  "onboarding.step.reminder": "Reminder",
  "onboarding.sidebarTitle": "Get started quickly",
  "onboarding.sidebarSubtitle": "Follow these {count} steps to set everything up. In your profile you choose between a private or business account and fill in your address details.",
  "onboarding.progressLabel": "{completed} of {total} completed",
  "onboarding.stepBadge": "Step {current} of {total}",
  "onboarding.skipStep": "Skip step",
  "onboarding.profile.title": "Complete your landlord profile",
  "onboarding.profile.description": "Choose your account type and fill in your address details. For a business account, a company name and VAT number are required, and you can optionally store a billing address.",
  "onboarding.profile.billingHelp": "Optional. Leave empty if this is the same as your regular address.",
  "onboarding.profile.next": "Next: add property",
  "onboarding.property.title": "Add your first property",
  "onboarding.property.description": "Enter the address of the property you manage. You can always add more properties later.",
  "onboarding.property.typeLabel": "Property type",
  "onboarding.property.next": "Next: add tenant",
  "onboarding.tenant.title": "Link a tenant",
  "onboarding.tenant.description": "Add the first tenant for {property}.",
  "onboarding.tenant.descriptionNoProperty": "Add the first tenant for your property.",
  "onboarding.tenant.firstNamePlaceholder": "John",
  "onboarding.tenant.lastNamePlaceholder": "Smith",
  "onboarding.tenant.next": "Next: add document",
  "onboarding.document.title": "Upload a first document",
  "onboarding.document.description": "Add a document such as an EPC certificate, rental agreement or insurance policy. You can also skip this step.",
  "onboarding.document.typeLabel": "Document type",
  "onboarding.document.uploadedNotice": "Uploaded",
  "onboarding.document.uploadedHint": "Select a new file below to replace it.",
  "onboarding.document.optionalReplace": "(optional - replaces current document)",
  "onboarding.document.fileDropIcon": "File",
  "onboarding.document.fileDropText": "Drop a file here or click to browse",
  "onboarding.document.fileDropHint": "PDF, JPG, PNG - max. 20 MB",
  "onboarding.document.next": "Next: set reminder",
  "onboarding.csvImportFileRequired": "Choose the completed CSV file first.",
  "onboarding.csvImportSuccess": "{propertyCount} properties and {tenantCount} tenants imported.",
  "onboarding.csvImportRowError": "Row {rowNumber}: {message}",
  "onboarding.csvImportInvalidData": "Invalid data.",
  "onboarding.csvImportError": "The import failed. Try again with the template file.",
  "onboarding.error.companyNameRequired": "Enter a company name.",
  "onboarding.error.profileRequired": "Enter street, house number, postal code, city and country.",
  "onboarding.error.countryNotAllowed": "This country is not allowed on Rentomax.",
  "onboarding.error.propertyAddressRequired": "Enter an address for the property.",
  "onboarding.error.tenantRequired": "Fill in the required tenant details or skip this step.",
  "onboarding.error.documentFileRequired": "Choose a file to upload, or skip this step.",
  "onboarding.error.reminderRequired": "Enter a description and date, or skip this step.",
  "onboarding.error.vatNumberRequired": "Enter a VAT number.",
  "onboarding.error.complete": "Onboarding could not be completed.",
  "survey.public.loading": "Loading...",
  "survey.public.notFoundTitle": "Survey not found",
  "survey.public.notFoundBody": "This link is invalid or expired.",
  "survey.public.errorTitle": "Something went wrong",
  "survey.public.errorBody": "Try reloading the page.",
  "survey.public.answeredTitle": "You already responded",
  "survey.public.answeredBody": "Your response for {year} was already recorded. Thank you!",
  "survey.public.submittedTitle": "Thank you for your feedback!",
  "survey.public.submittedBody": "Your response was sent to {landlordName}.",
  "survey.public.formTitle": "How satisfied are you with your rental home and the service?",
  "survey.public.starLabel": "{count} star",
  "survey.public.commentPlaceholder": "Optional comment...",
  "survey.public.submit": "Send my response",
  "survey.public.submitting": "Sending...",
  "survey.public.ratingError": "Please choose a rating (1-5 stars).",
  "site.title": "Rentomax",
  "common.daysShort": "{count}d",
  "common.daysAgo": "{count} days ago",
  "common.daysRemaining": "{count} days remaining",
  "common.processing": "Working...",
  "document.type.epc": "EPC",
  "onboarding.reminder.title": "Set a first reminder",
  "onboarding.reminder.description": "Reminders help you keep deadlines and tasks in view. Create one now to get started.",
  "onboarding.reminder.suggestionsLabel": "Quick suggestions:",
  "onboarding.reminder.suggestion.epcLabel": "Renew EPC",
  "onboarding.reminder.suggestion.epcTitle": "Renew EPC certificate",
  "onboarding.reminder.suggestion.electricalLabel": "Electrical inspection",
  "onboarding.reminder.suggestion.electricalTitle": "Electrical inspection",
  "onboarding.reminder.suggestion.insuranceLabel": "Fire insurance",
  "onboarding.reminder.suggestion.insuranceTitle": "Renew fire insurance",
  "onboarding.reminder.suggestion.indexationLabel": "Rent indexation",
  "onboarding.reminder.suggestion.indexationTitle": "Track rent indexation",
  "onboarding.reminder.titlePlaceholder": "E.g. renew EPC certificate",
  "onboarding.reminder.checkoutDescription": "After this step, we will send you to Mollie to start your subscription.",
  "onboarding.reminder.dashboardDescription": "After this step, we will finish your onboarding and take you straight to your dashboard with your trial.",
  "onboarding.reminder.skipCheckout": "Skip step - go to Mollie",
  "onboarding.reminder.finishCheckout": "Finish - go to Mollie",
  "onboarding.reminder.finishDashboard": "Finish - go to dashboard",
  "onboarding.reminder.finish": "Finish - go to dashboard",
  "agreement.rentChange.currentAgreementStep": "Current<br>agreement",
  "agreement.rentChange.newAgreementStep": "New<br>agreement",
  "agreement.rentChange.confirmStep": "Confirmation",
  "agreement.rentChange.closeCurrentHelp": "Close the current agreement by entering an end date.",
  "agreement.rentChange.setupNewHelp": "Set the new agreement that starts after the current one ends.",
  "agreement.rentChange.reviewHelp": "Review the changes and confirm.",
  "agreement.rentChange.newRentAmount": "New rent amount (EUR/month)",
  "property.documents.empty": "No documents for this property.",
  "property.reminders.empty": "No reminders for this property.",
  "property.tenants.addButton": "New tenant",
  "property.tenants.linkExistingButton": "Link existing",
  "property.tenants.empty": "No tenants linked to this property.",
  "tenant.documents.empty": "No documents for this tenant.",
  "tenant.timeline.allAgreements": "All rental agreements",
  "tenantWelcome.sectionTitle": "Welcome page",
  "tenantWelcome.manageButton": "Welcome page",
  "tenantWelcome.status.notConfigured": "Not configured",
  "tenantWelcome.status.inactive": "Inactive",
  "tenantWelcome.status.active": "Active",
  "tenantWelcome.status.ended": "Blocked for previous tenant",
  "tenantWelcome.publicLink": "Personal link",
  "tenantWelcome.linkUnavailable": "Save the welcome page first to generate a personal link.",
  "tenantWelcome.help": "Bundle recurring practical information for this tenant on a personal page without an account. The link always shows the latest version.",
  "tenantWelcome.pageTitle": "Title",
  "tenantWelcome.pageTitlePlaceholder": "Welcome to your home",
  "tenantWelcome.introduction": "Intro",
  "tenantWelcome.introductionPlaceholder": "Short welcome message or first practical explanation...",
  "tenantWelcome.houseRules": "House rules",
  "tenantWelcome.houseRulesPlaceholder": "For example: keep shared spaces tidy, quiet after 10 PM...",
  "tenantWelcome.wifiName": "Wi-Fi network",
  "tenantWelcome.wifiNamePlaceholder": "Wi-Fi network name",
  "tenantWelcome.wifiPassword": "Wi-Fi password",
  "tenantWelcome.wifiPasswordPlaceholder": "Wi-Fi password",
  "tenantWelcome.trashCollectionInfo": "Trash collection",
  "tenantWelcome.trashCollectionPlaceholder": "Which day, which bins and where to put them...",
  "tenantWelcome.parkingInfo": "Parking info",
  "tenantWelcome.parkingPlaceholder": "Where can the tenant park? Is a badge or code needed?",
  "tenantWelcome.additionalInfo": "Extra info",
  "tenantWelcome.additionalInfoPlaceholder": "Anything else that helps: basement, meters, bike storage...",
  "tenantWelcome.contactsTitle": "Emergency contacts",
  "tenantWelcome.addContact": "Add contact",
  "tenantWelcome.contactLabelPlaceholder": "For example plumber",
  "tenantWelcome.contactNamePlaceholder": "Name",
  "tenantWelcome.contactPhonePlaceholder": "Phone number",
  "tenantWelcome.saveDraft": "Save",
  "tenantWelcome.activateButton": "Activate",
  "tenantWelcome.inactiveWarning": "This welcome page is currently inactive.",
  "tenantWelcome.deactivateButton": "Deactivate",
  "tenantWelcome.copyLink": "Copy link",
  "tenantWelcome.copySuccess": "Link copied.",
  "tenantWelcome.copyError": "Copying the link failed.",
  "tenantWelcome.qrTitle": "Tenant QR code",
  "tenantWelcome.qrHelp": "This QR code opens the public welcome page and public damage report form for this tenant.",
  "tenantWelcome.qrAlt": "QR code to public welcome page",
  "tenantWelcome.qrError": "The QR code could not be generated.",
  "tenantWelcome.printQr": "Print QR code",
  "tenantWelcome.printQrError": "The print window could not be opened.",
  "tenantWelcome.printTitle": "Tenant QR code",
  "tenantWelcome.qrPrintEyebrow": "Scan to report damage",
  "tenantWelcome.qrPrintBody": "Scan this code to open the public welcome page and damage report form for this property.",
  "tenantWelcome.openPublicPage": "Open public page",
  "tenantWelcome.endedTenantWarning": "This tenant no longer has an active tenancy. The public page stays blocked until there is an active rental period again.",
  "tenantWelcome.updatedAt": "Last updated",
  "tenantWelcome.public.loading": "Loading...",
  "tenantWelcome.public.notFoundTitle": "Welcome page not found",
  "tenantWelcome.public.notFoundBody": "This link is invalid or deactivated.",
  "tenantWelcome.public.errorTitle": "Something went wrong",
  "tenantWelcome.public.errorBody": "Try reloading the page.",
  "tenantWelcome.public.wifiTitle": "Wi-Fi",
  "tenantWelcome.public.damageReport.title": "Report damage",
  "tenantWelcome.public.damageReport.helper": "Quickly report damage or an issue for this property. Your landlord will receive it in the file.",
  "tenantWelcome.public.damageReport.noLogin": "No login needed",
  "tenantWelcome.public.damageReport.descriptionLabel": "What is happening?",
  "tenantWelcome.public.damageReport.descriptionPlaceholder": "Briefly describe what is damaged or where the issue is located.",
  "tenantWelcome.public.damageReport.urgencyLabel": "Urgency",
  "tenantWelcome.public.damageReport.photosLabel": "Add photos",
  "tenantWelcome.public.damageReport.submit": "Send damage report",
  "tenantWelcome.public.damageReport.submitError": "The damage report could not be sent.",
  "tenantWelcome.public.damageReport.success": "Your report was sent. The landlord can follow it up now.",
  "publicProperty.loading": "Loading...",
  "publicProperty.notFoundTitle": "Property page not found",
  "publicProperty.notFoundBody": "This link is invalid, disabled or expired.",
  "publicProperty.errorTitle": "Something went wrong",
  "publicProperty.errorBody": "Try reloading the page.",
  "publicProperty.hostedBy": "Shared by {name}",
  "publicProperty.noDescription": "The landlord has not added an extra description for this property yet.",
  "publicProperty.previewType": "Type",
  "publicProperty.previewStatus": "Status",
  "publicProperty.photosCount": "Photos",
  "publicProperty.galleryTitle": "Photo gallery",
  "publicProperty.gallerySubtitle": "A first look at the property as presented by the landlord.",
  "publicProperty.galleryEmpty": "No photos are available for this property yet.",
  "publicProperty.galleryPhotoAlt": "Property photo: {{fileName}}",
  "publicProperty.openPreview": "Open property photo {{fileName}}",
  "publicProperty.lightboxTitle": "Enlarge property photo",
  "publicProperty.closePreview": "Close photo preview",
  "publicProperty.previous": "Previous photo",
  "publicProperty.next": "Next photo",
  "publicProperty.position": "Photo {{current}} of {{total}}",
  "publicProperty.applyTitle": "Apply as a candidate",
  "publicProperty.applySubtitle": "Confirm through Rentomax that you want to apply for this property.",
  "publicProperty.applySuccess": "Your application was registered. The landlord now sees you as a candidate tenant in Rentomax.",
  "publicProperty.applyLoginRequired": "Sign in by email, Google, or Microsoft before applying.",
  "publicProperty.applyLoginButton": "Sign in to apply",
  "publicProperty.applyLandlordModeBlocked": "You cannot apply with a landlord account. Switch your account mode first on the My profile page.",
  "publicProperty.applyGoToProfile": "Go to My profile",
  "publicProperty.applyOnboardingRequired": "Complete your tenant profile with your name and address first.",
  "publicProperty.applyCompleteProfile": "Complete profile",
  "publicProperty.applyConfirmPrompt": "Confirm that you want to apply for this property.",
  "publicProperty.applyConfirmButton": "Confirm application",
  "publicProperty.applyBrowserConfirm": "Do you want to apply for this property?",
  "publicProperty.applyError": "Your application could not be saved.",
  "tenantOnboarding.intro": "Complete your name and address details before applying.",
  "tenantOnboarding.firstName": "First name",
  "tenantOnboarding.lastName": "Last name",
  "tenantOnboarding.saveAndContinue": "Save and continue",
  "tenantOnboarding.requiredError": "Complete your first name, last name, and address details.",
  "tenantOnboarding.saveError": "Your profile could not be saved.",
  "tenantInvite.title": "Create your free tenant account",
  "tenantInvite.subtitle": "Use this invitation to link your record in Rentomax to your own tenant account.",
  "tenantInvite.freeNote": "Your tenant account on Rentomax is completely free and will remain free.",
  "tenantInvite.invitedBySuffix": "invited you through Rentomax.",
  "tenantInvite.loginCta": "Continue to sign in by email, Google, or Microsoft",
  "tenantInvite.claiming": "Linking this invitation to your tenant account...",
  "tenantInvite.success": "Your invitation is linked.",
  "tenantInvite.successBody": "You can now see this record in your tenant portal as well.",
  "tenantInvite.portalCta": "Open my tenant portal",
  "tenantInvite.profileCta": "Open my profile",
  "tenantInvite.loadError": "This invitation is not available.",
  "tenantInvite.claimError": "The invitation could not be linked.",
  "tenantPortal.title": "My properties",
  "tenantPortal.description": "Review the properties you applied for and the rental relationships linked to your account.",
  "tenantPortal.candidateTitle": "Applications",
  "tenantPortal.activeTitle": "Active rental agreements",
  "tenantPortal.futureTitle": "Upcoming rental agreements",
  "tenantPortal.pastTitle": "Past rental agreements",
  "tenantPortal.eyebrow": "Tenant portal",
  "tenantPortal.activeDescription": "A focused overview of the rental relationships that are currently active on your account.",
  "tenantPortal.futureDescription": "See which rental relationships are starting soon so you can stay ahead of the move-in timeline.",
  "tenantPortal.candidateDescription": "Track which properties you applied for and where your tenant profile is already known.",
  "tenantPortal.pastDescription": "A clear archive of rental relationships that ended but remain linked to your account history.",
  "tenantPortal.currentSectionCount": "Items in this section",
  "tenantPortal.navigationLabel": "Tenant portal navigation",
  "tenantPortal.statActive": "Active now",
  "tenantPortal.statUpcoming": "Starting later",
  "tenantPortal.statApplications": "Applications",
  "tenantPortal.statHistory": "History",
  "tenantPortal.propertyStatus": "Property status",
  "tenantPortal.interestDate": "Applied on",
  "tenantPortal.startDate": "Start date",
  "tenantPortal.endDate": "End date",
  "tenantPortal.rentAmount": "Rent",
  "tenantPortal.viewWelcomePage": "View welcome page",
  "tenantPortal.notAvailable": "Not available yet",
  "tenantPortal.loading": "Loading your tenant portal...",
  "tenantPortal.loadError": "The tenant portal could not be loaded.",
  "tenantPortal.emptyTitle": "Nothing to show yet",
  "tenantPortal.emptyBody": "As soon as something is linked in this category, it will appear here automatically.",
  "tenantPortal.empty": "No properties in this list.",
  "tenantPortal.damageReports.title": "Report damage or a problem",
  "tenantPortal.damageReports.helper": "Use this form to record an issue for this active rental agreement.",
  "tenantPortal.damageReports.empty": "There are no reports for this rental agreement yet.",
  "tenantPortal.damageReports.descriptionLabel": "Problem description",
  "tenantPortal.damageReports.descriptionPlaceholder": "Describe what is happening and where the issue is located.",
  "tenantPortal.damageReports.photosLabel": "Photos",
  "tenantPortal.damageReports.submit": "Send report",
  "tenantPortal.damageReports.submitError": "The report could not be sent.",
  "damageReports.pageDescription": "Review all damage and problem reports that tenants submitted for your properties.",
  "damageReports.empty": "There are no damage or problem reports yet.",
  "damageReports.loadError": "The reports could not be loaded.",
  "damageReports.propertyEmpty": "There are no reports for this property yet.",
  "damageReports.openPropertyDetail": "Open property detail",
  "damageReports.urgency.low": "Low urgency",
  "damageReports.urgency.normal": "Normal urgency",
  "damageReports.urgency.high": "High urgency",
  "damageReports.urgency.urgent": "Urgent",
  "profile.accountModeTitle": "Account mode",
  "profile.accountModeTenantDescription": "Your account is in tenant mode. You can review your applications and linked rental relationships without a subscription.",
  "profile.accountModeLandlordDescription": "Your account is in landlord mode. You manage the paid platform and can switch back to tenant mode at any time.",
  "profile.accountModeSwitchToLandlordTitle": "Switch to landlord mode?",
  "profile.accountModeSwitchToLandlordConfirm": "Landlord mode gives access to the paid platform. You need a paid subscription to use those features.",
  "profile.accountModeSwitchToTenantTitle": "Switch to tenant mode?",
  "profile.accountModeSwitchToTenantConfirm": "Tenant mode is only meant for renting properties from someone else. Use it to manage your applications and rental relationships.",
  "profile.switchToLandlord": "Switch to landlord mode",
  "profile.switchToTenant": "Switch to tenant mode",
  "profile.accountModeTenantActivated": "Your account is now in tenant mode.",
  "profile.accountModeLandlordActivated": "Your account is now in landlord mode.",
  "profile.accountModeLandlordTrialActivated": "Your account is now in landlord mode and your trial has started.",
  "profile.accountModeSwitchError": "The account mode could not be changed.",
  "profile.accountMembers.title": "Account members",
  "profile.accountMembers.description": "Give a partner, family member, or agent access to the same account data.",
  "profile.accountMembers.empty": "No extra account members yet.",
  "profile.accountMembers.pendingTitle": "Pending invitations",
  "profile.accountMembers.emailLabel": "Email address",
  "profile.accountMembers.roleLabel": "Role",
  "profile.accountMembers.role.owner": "Owner",
  "profile.accountMembers.role.manager": "Co-manager",
  "profile.accountMembers.role.reader": "Reader",
  "profile.accountMembers.you": "you",
  "profile.accountMembers.inviteButton": "Send invitation",
  "profile.accountMembers.inviteSent": "The invitation was sent.",
  "profile.accountMembers.inviteError": "The invitation could not be sent.",
  "profile.accountMembers.claimSuccess": "Shared account access is now active.",
  "profile.accountMembers.claimError": "The invitation could not be activated.",
  "profile.accountMembers.removeButton": "Remove",
  "profile.accountMembers.removeConfirm": "Remove this account member from the shared account?",
  "profile.accountMembers.removeSuccess": "The account member was removed.",
  "profile.accountMembers.removeError": "The account member could not be removed.",
  "profile.accountMembers.loadError": "The account members could not be loaded.",
  "profile.accountMembers.readerProfileNotice": "You have read-only access. Only the owner or a co-manager can update account details.",
  "profile.accountMembers.readerBillingNotice": "You have read-only access. Only the owner or a co-manager can manage subscriptions.",
  "insurance.tabTitle": "Insurances",
  "insurance.add": "Add insurance",
  "insurance.new": "New insurance",
  "insurance.edit": "Edit insurance",
  "insurance.empty": "No insurances added for this property yet.",
  "insurance.loadError": "Failed to load insurances.",
  "insurance.confirmDelete": "Are you sure you want to delete this insurance?",
  "insurance.companyName": "Insurance company",
  "insurance.companyNamePlaceholder": "e.g. AG Insurance, KBC, Axa",
  "insurance.policyNumber": "Policy number",
  "insurance.policyNumberPlaceholder": "e.g. POL-2024-12345",
  "insurance.notesPlaceholder": "Optional notes...",
  "insurance.type.Brandverzekering": "Fire insurance",
  "insurance.type.Aansprakelijkheid": "Liability",
  "insurance.type.Huurwaarborgverzekering": "Rental guarantee insurance",
  "insurance.type.Rechtsbijstand": "Legal aid",
  "maintenanceActivities.tabTitle": "Maintenance log",
  "maintenanceActivities.add": "Add activity",
  "maintenanceActivities.empty": "No maintenance activities have been logged for this property yet.",
  "maintenanceActivities.descriptionPlaceholder": "Describe what happened or what is planned.",
  "maintenanceActivities.amountOptional": "Amount (optional)",
  "maintenanceActivities.attachmentOptional": "Attachment (optional)",
  "maintenanceActivities.planned": "Planned",
  "maintenanceActivities.completed": "Completed",
  "maintenanceActivities.confirmDelete": "Do you want to delete this maintenance activity?",
  "maintenanceActivities.saveError": "The maintenance activity could not be saved.",
  "maintenanceActivities.uploadError": "The attachment could not be uploaded.",
  "maintenanceActivities.category.maintenance": "Maintenance",
  "maintenanceActivities.category.repair": "Repair",
  "maintenanceActivities.category.inspection": "Inspection",
  "maintenanceActivities.category.renovation": "Renovation",
  "maintenanceActivities.category.other": "Other",
  "billing.newSubscriptionsDisabled": "Starting new subscriptions is temporarily disabled. Existing subscriptions and automatic renewals continue normally.",
  "billing.userNewSubscriptionsDisabled": "Starting a new paid subscription is disabled for this account. Contact support if this needs to change.",
  "admin.newSubscriptionAccess.sectionTitle": "New subscriptions",
  "admin.newSubscriptionAccess.sectionDescription": "Control whether existing accounts without a paid subscription may still start a new subscription. Existing subscriptions and automatic renewals continue normally.",
  "admin.newSubscriptionAccess.enabled": "New subscriptions allowed",
  "admin.newSubscriptionAccess.disabled": "New subscriptions blocked",
  "admin.newSubscriptionAccess.toggleLabel": "On/off",
  "admin.newSubscriptionAccess.saveError": "The new subscription access setting could not be saved.",
  "admin.allowedCountries.sectionTitle": "Allowed countries",
  "admin.allowedCountries.sectionDescription": "Only these countries may sign in and be selected in country fields across the platform.",
  "admin.allowedCountries.saveButton": "Save countries",
  "admin.allowedCountries.saveError": "The allowed countries could not be saved.",
  "admin.advertising.sectionTitle": "Right-side ad slot",
  "admin.advertising.sectionDescription": "Control whether Rentomax shows a subtle vertical ad slot on regular desktop app pages. Admin pages do not show this slot.",
  "admin.advertising.enabled": "Ad slot visible",
  "admin.advertising.disabled": "Ad slot disabled",
  "admin.advertising.toggleLabel": "On/off",
  "admin.advertising.saveError": "The advertising setting could not be saved."
}
